export default {
    sequela_7: 'Acute typhoid infection',
    sequela_8: 'Severe typhoid fever',
    sequela_9: 'Intestinal perforation due to typhoid',
    sequela_10: 'Acute paratyphoid infection',
    sequela_11: 'Moderate paratyphoid fever',
    sequela_12: 'Severe paratyphoid fever',
    sequela_13: 'Intestinal perforation due to paratyphoid',
    sequela_14: 'Other intestinal infectious diseases',
    sequela_15: 'Mild upper respiratory infections',
    sequela_16: 'Moderate upper respiratory infections',
    sequela_17: 'Guillain-Barré syndrome due to upper respiratory infections',
    sequela_18: 'Acute otitis media',
    sequela_19: 'Acute pneumococcal meningitis',
    sequela_20: 'Mild behavioral problems due to pneumococcal meningitis',
    sequela_21: 'Mild motor impairment due to long term due to pneumococcal meningitis',
    sequela_22: 'Mild motor plus cognitive impairments due to pneumococcal meningitis',
    sequela_23: 'Borderline intellectual disability due to pneumococcal meningitis',
    sequela_24: 'Mild intellectual disability due to pneumococcal meningitis',
    sequela_25: 'Moderate motor impairment due to pneumococcal meningitis',
    sequela_26: 'Severe motor impairment due to pneumococcal meningitis',
    sequela_27: 'Moderate motor plus cognitive impairments due to pneumococcal meningitis',
    sequela_28: 'Severe motor plus cognitive impairments due to pneumococcal meningitis',
    sequela_29: 'Epilepsy due to pneumococcal meningitis',
    sequela_30: 'Mild hearing loss due to pneumococcal meningitis',
    sequela_31: 'Mild hearing loss with ringing due to pneumococcal meningitis',
    sequela_32: 'Moderate hearing loss due to pneumococcal meningitis',
    sequela_33: 'Moderate hearing loss with ringing due to pneumococcal meningitis',
    sequela_34: 'Moderately severe hearing loss due to pneumococcal meningitis',
    sequela_35: 'Moderately severe hearing loss with ringing due to pneumococcal meningitis',
    sequela_36: 'Severe hearing loss due to pneumococcal meningitis',
    sequela_37: 'Severe hearing loss with ringing due to pneumococcal meningitis',
    sequela_38: 'Profound hearing loss due to pneumococcal meningitis',
    sequela_39: 'Profound hearing loss with ringing due to pneumococcal meningitis',
    sequela_40: 'Complete hearing loss due to pneumococcal meningitis',
    sequela_41: 'Complete hearing loss with ringing due to pneumococcal meningitis',
    sequela_42: 'Acute H influenzae type B meningitis',
    sequela_43: 'Mild behavioral problems due to H influenzae type B meningitis',
    sequela_44: 'Mild motor impairment due to long term due to H influenzae type B meningitis',
    sequela_45: 'Mild motor plus cognitive impairments due to H influenzae type B meningitis',
    sequela_46: 'Borderline intellectual disability due to H influenzae type B meningitis',
    sequela_47: 'Mild intellectual disability due to H influenzae type B meningitis',
    sequela_48: 'Moderate motor impairment due to H influenzae type B meningitis',
    sequela_49: 'Severe motor impairment due to H influenzae type B meningitis',
    sequela_50: 'Moderate motor plus cognitive impairments due to H influenzae type B meningitis',
    sequela_51: 'Severe motor plus cognitive impairments due to H influenzae type B meningitis',
    sequela_52: 'Epilepsy due to H influenzae type B meningitis',
    sequela_53: 'Mild hearing loss due to H influenzae type B meningitis',
    sequela_54: 'Mild hearing loss with ringing due to H influenzae type B meningitis',
    sequela_55: 'Moderate hearing loss due to H influenzae type B meningitis',
    sequela_56: 'Moderate hearing loss with ringing due to H influenzae type B meningitis',
    sequela_57: 'Moderately severe hearing loss due to H influenzae type B meningitis',
    sequela_58: 'Moderately severe hearing loss with ringing due to H influenzae type B meningitis',
    sequela_59: 'Severe hearing loss due to H influenzae type B meningitis',
    sequela_60: 'Severe hearing loss with ringing due to H influenzae type B meningitis',
    sequela_61: 'Profound hearing loss due to H influenzae type B meningitis',
    sequela_62: 'Profound hearing loss with ringing due to H influenzae type B meningitis',
    sequela_63: 'Complete hearing loss due to H influenzae type B meningitis',
    sequela_64: 'Complete hearing loss with ringing due to H influenzae type B meningitis',
    sequela_65: 'Acute meningococcal meningitis',
    sequela_66: 'Mild behavioral problems due to meningococcal meningitis',
    sequela_67: 'Mild motor impairment due to long term due to meningococcal meningitis',
    sequela_68: 'Mild motor plus cognitive impairments due to meningococcal meningitis',
    sequela_69: 'Borderline intellectual disability due to meningococcal meningitis',
    sequela_70: 'Mild intellectual disability due to meningococcal meningitis',
    sequela_71: 'Moderate motor impairment due to meningococcal meningitis',
    sequela_72: 'Severe motor impairment due to meningococcal meningitis',
    sequela_73: 'Moderate motor plus cognitive impairments due to meningococcal meningitis',
    sequela_74: 'Severe motor plus cognitive impairments due to meningococcal meningitis',
    sequela_75: 'Epilepsy due to meningococcal meningitis',
    sequela_76: 'Mild hearing loss due to meningococcal meningitis',
    sequela_77: 'Mild hearing loss with ringing due to meningococcal meningitis',
    sequela_78: 'Moderate hearing loss due to meningococcal meningitis',
    sequela_79: 'Moderate hearing loss with ringing due to meningococcal meningitis',
    sequela_80: 'Moderately severe hearing loss due to meningococcal meningitis',
    sequela_81: 'Moderately severe hearing loss with ringing due to meningococcal meningitis',
    sequela_82: 'Severe hearing loss due to meningococcal meningitis',
    sequela_83: 'Severe hearing loss with ringing due to meningococcal meningitis',
    sequela_84: 'Profound hearing loss due to meningococcal meningitis',
    sequela_85: 'Profound hearing loss with ringing due to meningococcal meningitis',
    sequela_86: 'Complete hearing loss due to meningococcal meningitis',
    sequela_87: 'Complete hearing loss with ringing due to meningococcal meningitis',
    sequela_88: 'Other acute bacterial meningitis',
    sequela_89: 'Mild behavioral problems due to other bacterial meningitis',
    sequela_90: 'Mild motor impairment due to long term due to other bacterial meningitis',
    sequela_91: 'Mild motor plus cognitive impairments due to other bacterial meningitis',
    sequela_92: 'Borderline intellectual disability due to other bacterial meningitis',
    sequela_93: 'Mild intellectual disability due to other bacterial meningitis',
    sequela_94: 'Moderate motor impairment due to other bacterial meningitis',
    sequela_95: 'Severe motor impairment due to other bacterial meningitis',
    sequela_96: 'Moderate motor plus cognitive impairments due to other bacterial meningitis',
    sequela_97: 'Severe motor plus cognitive impairments due to other bacterial meningitis',
    sequela_98: 'Epilepsy due to other meningitis',
    sequela_99: 'Mild hearing loss due to other bacterial meningitis',
    sequela_100: 'Mild hearing loss due with ringing to other bacterial meningitis',
    sequela_101: 'Moderate hearing loss due to other bacterial meningitis',
    sequela_102: 'Moderate hearing loss with ringing due to other bacterial meningitis',
    sequela_103: 'Moderately severe hearing loss due to other bacterial meningitis',
    sequela_104: 'Moderately severe hearing loss with ringing due to other bacterial meningitis',
    sequela_105: 'Severe hearing loss due to other bacterial meningitis',
    sequela_106: 'Severe hearing loss with ringing due to other bacterial meningitis',
    sequela_107: 'Profound hearing loss due to other bacterial meningitis',
    sequela_108: 'Profound hearing loss with ringing due to other bacterial meningitis',
    sequela_109: 'Complete hearing loss due to other bacterial meningitis',
    sequela_110: 'Complete hearing loss with ringing due to other bacterial meningitis',
    sequela_111: 'Acute viral meningitis',
    sequela_112: 'Acute encephalitis',
    sequela_113: 'Moderate diphtheria',
    sequela_114: 'Severe diphtheria',
    sequela_115: 'Whooping cough',
    sequela_116: 'Severe tetanus',
    sequela_117: 'Moderate measles',
    sequela_118: 'Severe measles',
    sequela_119: 'Chickenpox',
    sequela_120: 'Herpes zoster',
    sequela_121: 'Mild malaria',
    sequela_122: 'Moderate malaria',
    sequela_123: 'Severe malaria',
    sequela_124: 'Acute Chagas disease',
    sequela_125: 'Atrial fibrillation and flutter due to Chagas disease',
    sequela_126: 'Mild chronic digestive disease due to Chagas disease',
    sequela_127: 'Moderate chronic digestive disease due to Chagas disease',
    sequela_128: 'Mild heart failure due to Chagas disease',
    sequela_129: 'Moderate heart failure due to Chagas disease',
    sequela_130: 'Severe heart failure due to Chagas disease',
    sequela_131: 'Moderate visceral leishmaniasis',
    sequela_132: 'Severe visceral leishmaniasis',
    sequela_133: 'Cutaneous and mucocutaneous leishmaniasis',
    sequela_136: 'Mild schistosomiasis',
    sequela_137: 'Mild diarrhea due to schistosomiasis',
    sequela_138: 'Hematemesis due to schistosomiasis',
    sequela_139: 'Hepatomegaly due to schistosomiasis',
    sequela_140: 'Ascites due to schistosomiasis',
    sequela_141: 'Dysuria due to schistosomiasis',
    sequela_142: 'Bladder pathology due to schistosomiasis',
    sequela_143: 'Hydronephrosis due to schistosomiasis',
    sequela_144: 'Mild anemia due to schistosomiasis',
    sequela_145: 'Moderate anemia due to schistosomiasis',
    sequela_146: 'Severe anemia due to schistosomiasis',
    sequela_147: 'Abdominal problems due to cystic echinococcosis',
    sequela_148: 'Chronic respiratory disease due to cystic echinococcosis',
    sequela_149: 'Prevalence of detectable microfiliaria due to lymphatic filariasis',
    sequela_150: 'Lymphedema due to lymphatic filariasis',
    sequela_151: 'Hydrocele due to lymphatic filariasis',
    sequela_152: 'Mild skin disease due to onchocerciasis',
    sequela_153: 'Moderate skin disease due to onchocerciasis',
    sequela_154: 'Moderate vision impairment due to trachoma',
    sequela_155: 'Severe vision impairment due to trachoma',
    sequela_156: 'Blindness due to trachoma',
    sequela_157: 'Moderate dengue',
    sequela_158: 'Severe dengue',
    sequela_159: 'Post-dengue chronic fatigue syndrome',
    sequela_160: 'Moderate yellow fever',
    sequela_161: 'Severe yellow fever',
    sequela_162: 'Rabies',
    sequela_163: 'Heavy infestation of ascariasis',
    sequela_164: 'Mild abdominopelvic problems due to ascariasis',
    sequela_165: 'Severe wasting due to ascariasis',
    sequela_166: 'Heavy infestation of trichuriasis',
    sequela_167: 'Mild abdominopelvic problems due to trichuriasis',
    sequela_168: 'Severe wasting due to trichuriasis',
    sequela_169: 'Heavy infestation of hookworm',
    sequela_170: 'Mild abdominopelvic problems due to hookworm disease',
    sequela_171: 'Severe wasting due to hookworm disease',
    sequela_172: 'Mild anemia due to hookworm disease',
    sequela_173: 'Moderate anemia due to hookworm disease',
    sequela_174: 'Severe anemia due to hookworm disease',
    sequela_175: 'Cerebral paragonimiasis',
    sequela_176: 'Acute infection due to other neglected tropical diseases',
    sequela_177: 'Mild anemia due to other neglected tropical diseases',
    sequela_178: 'Moderate anemia due to other neglected tropical diseases',
    sequela_179: 'Severe anemia due to other neglected tropical diseases',
    sequela_180: 'Maternal hemorrhage (< 1L blood lost)',
    sequela_181: 'Maternal hemorrhage (> 1L blood lost)',
    sequela_182: 'Mild anemia due to maternal hemorrhage',
    sequela_183: 'Moderate anemia due to maternal hemorrhage',
    sequela_184: 'Severe anemia due to maternal hemorrhage',
    sequela_185: 'Severe pre-eclampsia',
    sequela_186: 'Eclampsia',
    sequela_187: 'Long term sequelae of severe pre-eclampsia',
    sequela_188: 'Obstructed labor, acute event',
    sequela_189: 'Rectovaginal fistula',
    sequela_190: 'Vesicovaginal fistula',
    sequela_191: 'Maternal abortive outcome',
    sequela_192: 'Other maternal disorders',
    sequela_193: 'Mild vision impairment due to retinopathy of prematurity',
    sequela_194:
        'Mild motor plus cognitive impairments due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_195:
        'Mild motor impairment due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_197: 'Other neonatal disorders',
    sequela_198: 'Moderate wasting with edema',
    sequela_199: 'Severe wasting without edema',
    sequela_200: 'Visible goiter without symptoms',
    sequela_201: 'Visible goiter with severe intellectual disability due to iodine deficiency',
    sequela_202: 'Visible goiter with profound intellectual disability due to iodine deficiency',
    sequela_203: 'Moderate vision impairment loss due to vitamin A deficiency',
    sequela_204: 'Severe vision impairment loss due to vitamin A deficiency',
    sequela_205: 'Blindness due to vitamin A deficiency',
    sequela_206: 'Mild iron-deficiency anemia',
    sequela_207: 'Moderate iron-deficiency anemia',
    sequela_208: 'Severe iron-deficiency anemia',
    sequela_212: 'Other nutritional deficiencies',
    sequela_214: 'Epididymo-orchitis due to chlamydial infection',
    sequela_215: 'Moderate pelvic inflammatory diseases due to chlamydial infection',
    sequela_216: 'Severe pelvic inflammatory diseases due to chlamydial infection',
    sequela_217: 'Primary infertility due to chlamydial infection',
    sequela_218: 'Secondary infertility due to chlamydial infection',
    sequela_219: 'Epididymo-orchitis due to gonococcal infection',
    sequela_220: 'Moderate pelvic inflammatory diseases due to gonococcal infection',
    sequela_221: 'Severe pelvic inflammatory diseases due to gonococcal infection',
    sequela_222: 'Primary infertility due to gonococcal infection',
    sequela_223: 'Secondary infertility due to gonococcal infection',
    sequela_224: 'Moderate pelvic inflammatory diseases due to other sexually transmitted diseases',
    sequela_225: 'Severe pelvic inflammatory diseases due to other sexually transmitted diseases',
    sequela_226: 'Primary infertility due to other sexually transmitted diseases',
    sequela_227: 'Secondary infertility due to other sexually transmitted diseases',
    sequela_229: 'Moderate acute hepatitis A',
    sequela_230: 'Severe acute hepatitis A',
    sequela_231: 'Moderate acute hepatitis B',
    sequela_232: 'Severe acute hepatitis B',
    sequela_233: 'Moderate acute hepatitis C',
    sequela_234: 'Severe acute hepatitis C',
    sequela_235: 'Moderate acute hepatitis E',
    sequela_236: 'Severe acute hepatitis E',
    sequela_237: 'Disfigurement level 1 due to leprosy',
    sequela_238: 'Disfigurement level 2 due to leprosy',
    sequela_240: 'Mild anemia due to other infectious diseases',
    sequela_241: 'Moderate anemia due to other infectious diseases',
    sequela_242: 'Severe anemia due to other infectious diseases',
    sequela_243: 'Guillain-Barré syndrome due to other infectious diseases',
    sequela_244: 'Diagnosis and primary therapy phase of esophageal cancer',
    sequela_245: 'Controlled phase of esophageal cancer',
    sequela_246: 'Metastatic phase of esophageal cancer',
    sequela_247: 'Terminal phase of esophageal cancer',
    sequela_248: 'Diagnosis and primary therapy phase of stomach cancer',
    sequela_249: 'Controlled phase of stomach cancer',
    sequela_250: 'Metastatic phase of stomach cancer',
    sequela_251: 'Terminal phase of stomach cancer',
    sequela_252: 'Diagnosis and primary therapy phase of liver cancer due to hepatitis B',
    sequela_253: 'Controlled phase of liver cancer due to hepatitis B',
    sequela_254: 'Metastatic phase of liver cancer due to hepatitis B',
    sequela_255: 'Terminal phase of liver cancer due to hepatitis B',
    sequela_256: 'Diagnosis and primary therapy phase of liver cancer due to hepatitis C',
    sequela_257: 'Controlled phase of liver cancer due to hepatitis C',
    sequela_258: 'Metastatic phase of liver cancer due to hepatitis C',
    sequela_259: 'Terminal phase of liver cancer due to hepatitis C',
    sequela_260: 'Diagnosis and primary therapy phase of liver cancer due to alcohol use',
    sequela_261: 'Controlled phase of liver cancer due to alcohol use',
    sequela_262: 'Metastatic phase of liver cancer due to alcohol use',
    sequela_263: 'Terminal phase of liver cancer due to alcohol use',
    sequela_264: 'Diagnosis and primary therapy phase of liver cancer due to other causes',
    sequela_265: 'Controlled phase of liver cancer due to other causes',
    sequela_266: 'Metastatic phase of liver cancer due to other causes',
    sequela_267: 'Terminal phase of liver cancer due to other causes',
    sequela_268: 'Diagnosis and primary therapy phase of larynx cancer',
    sequela_269: 'Controlled phase of larynx cancer',
    sequela_270: 'Metastatic phase of larynx cancer',
    sequela_271: 'Terminal phase of larynx cancer',
    sequela_273: 'Diagnosis and primary therapy phase of lung, bronchus, and trachea cancer',
    sequela_274: 'Controlled phase of lung, bronchus, and trachea cancer',
    sequela_275: 'Metastatic phase of lung, bronchus, and trachea cancer',
    sequela_276: 'Terminal phase of lung, bronchus, and trachea cancer',
    sequela_277: 'Diagnosis and primary therapy phase of breast cancer',
    sequela_278: 'Controlled phase of breast cancer',
    sequela_279: 'Metastatic phase of breast cancer',
    sequela_280: 'Terminal phase of breast cancer',
    sequela_282: 'Diagnosis and primary therapy phase of cervical cancer',
    sequela_283: 'Controlled phase of cervical cancer',
    sequela_284: 'Metastatic phase of cervical cancer',
    sequela_285: 'Terminal phase of cervical cancer',
    sequela_286: 'Diagnosis and primary therapy phase of uterine cancer',
    sequela_287: 'Controlled phase of uterine cancer',
    sequela_288: 'Metastatic phase of uterine cancer',
    sequela_289: 'Terminal phase of uterine cancer',
    sequela_290: 'Diagnosis and primary therapy phase of prostate cancer',
    sequela_291: 'Controlled phase of prostate cancer',
    sequela_292: 'Metastatic phase of prostate cancer',
    sequela_293: 'Terminal phase of prostate cancer',
    sequela_296: 'Diagnosis and primary therapy phase of colon and rectum cancers',
    sequela_297: 'Controlled phase of colon and rectum cancers',
    sequela_298: 'Metastatic phase of colon and rectum cancers',
    sequela_299: 'Terminal phase of colon and rectum cancers',
    sequela_301: 'Diagnosis and primary therapy phase of mouth cancer',
    sequela_302: 'Controlled phase of mouth cancer',
    sequela_303: 'Metastatic phase of mouth cancer',
    sequela_304: 'Terminal phase of mouth cancer',
    sequela_305: 'Diagnosis and primary therapy phase of nasopharynx cancer',
    sequela_306: 'Controlled phase of nasopharynx cancer',
    sequela_307: 'Metastatic phase of nasopharynx cancer',
    sequela_308: 'Terminal phase of nasopharynx cancer',
    sequela_309: 'Diagnosis and primary therapy phase of other pharynx cancer',
    sequela_310: 'Controlled phase of other pharynx cancer',
    sequela_311: 'Metastatic phase of other pharynx cancer',
    sequela_312: 'Terminal phase of other pharynx cancer',
    sequela_313: 'Diagnosis and primary therapy phase of gallbladder and biliary tract cancer',
    sequela_314: 'Controlled phase of gallbladder and biliary tract cancer',
    sequela_315: 'Metastatic phase of gallbladder and biliary tract cancer',
    sequela_316: 'Terminal phase of gallbladder and biliary tract cancer',
    sequela_317: 'Diagnosis and primary therapy phase of pancreatic cancer',
    sequela_318: 'Controlled phase of pancreatic cancer',
    sequela_319: 'Metastatic phase of pancreatic cancer',
    sequela_320: 'Terminal phase of pancreatic cancer',
    sequela_321: 'Diagnosis and primary therapy phase of malignant skin melanoma',
    sequela_322: 'Controlled phase of malignant skin melanoma',
    sequela_323: 'Metastatic phase of malignant skin melanoma',
    sequela_324: 'Terminal phase of malignant skin melanoma',
    sequela_329: 'Diagnosis and primary therapy phase of ovarian cancer',
    sequela_330: 'Controlled phase of ovarian cancer',
    sequela_331: 'Metastatic phase of ovarian cancer',
    sequela_332: 'Terminal phase of ovarian cancer',
    sequela_333: 'Diagnosis and primary therapy phase of testicular cancer',
    sequela_334: 'Controlled phase of testicular cancer',
    sequela_335: 'Metastatic phase of testicular cancer',
    sequela_336: 'Terminal phase of testicular cancer',
    sequela_337: 'Diagnosis and primary therapy phase of kidney cancer',
    sequela_338: 'Controlled phase of kidney cancer',
    sequela_339: 'Metastatic phase of kidney cancer',
    sequela_340: 'Terminal phase of kidney cancer',
    sequela_341: 'Diagnosis and primary therapy phase of bladder cancer',
    sequela_342: 'Controlled phase of bladder cancer',
    sequela_343: 'Metastatic phase of bladder cancer',
    sequela_344: 'Terminal phase of bladder cancer',
    sequela_346: 'Diagnosis and primary therapy phase of brain and nervous system cancers',
    sequela_347: 'Controlled phase of brain and nervous system cancers',
    sequela_348: 'Metastatic phase of brain and nervous system cancers',
    sequela_349: 'Terminal phase of brain and nervous system cancers',
    sequela_350: 'Diagnosis and primary therapy phase of thyroid cancer',
    sequela_351: 'Controlled phase of thyroid cancer',
    sequela_352: 'Metastatic phase of thyroid cancer',
    sequela_353: 'Terminal phase of thyroid cancer',
    sequela_354: 'Diagnosis and primary therapy phase of mesothelioma',
    sequela_355: 'Controlled phase of mesothelioma',
    sequela_356: 'Metastatic phase of mesothelioma',
    sequela_357: 'Terminal phase of mesothelioma',
    sequela_358: 'Diagnosis and primary therapy phase of Hodgkin disease',
    sequela_359: 'Controlled phase of Hodgkin disease',
    sequela_360: 'Metastatic phase of Hodgkin disease',
    sequela_361: 'Terminal phase of Hodgkin disease',
    sequela_362: 'Diagnosis and primary therapy phase of non-Hodgkin lymphoma',
    sequela_363: 'Controlled phase of non-Hodgkin lymphoma',
    sequela_364: 'Metastatic phase of non-Hodgkin lymphoma',
    sequela_365: 'Terminal phase of non-Hodgkin lymphoma',
    sequela_366: 'Diagnosis and primary therapy phase of multiple myeloma',
    sequela_367: 'Controlled phase of multiple myeloma',
    sequela_368: 'Metastatic phase of multiple myeloma',
    sequela_369: 'Terminal phase of multiple myeloma',
    sequela_378: 'Acute myocardial infarction first 2 days',
    sequela_379: 'Acute myocardial infarction 3 to 28 days',
    sequela_380: 'Mild angina due to ischemic heart disease',
    sequela_381: 'Moderate angina due to ischemic heart disease',
    sequela_382: 'Severe angina due to ischemic heart disease',
    sequela_383: 'Mild heart failure due to ischemic heart disease',
    sequela_384: 'Moderate heart failure due to ischemic heart disease',
    sequela_385: 'Severe heart failure due to ischemic heart disease',
    sequela_386: 'Acute ischemic stroke severity level 1',
    sequela_387: 'Acute ischemic stroke severity level 2',
    sequela_388: 'Acute ischemic stroke severity level 4',
    sequela_389: 'Acute ischemic stroke severity level 3',
    sequela_390: 'Acute ischemic stroke severity level 5',
    sequela_391: 'Chronic ischemic stroke severity level 1',
    sequela_392: 'Chronic ischemic stroke severity level 2',
    sequela_393: 'Chronic ischemic stroke severity level 4',
    sequela_394: 'Chronic ischemic stroke severity level 3',
    sequela_395: 'Chronic ischemic stroke severity level 5',
    sequela_396: 'Acute intracerebral hemorrhage severity level 1',
    sequela_397: 'Acute intracerebral hemorrhage severity level 2',
    sequela_398: 'Acute intracerebral hemorrhage severity level 4',
    sequela_399: 'Acute intracerebral hemorrhage severity level 3',
    sequela_400: 'Acute intracerebral hemorrhage severity level 5',
    sequela_401: 'Chronic intracerebral hemorrhage severity level 1',
    sequela_402: 'Chronic intracerebral hemorrhage severity level 2',
    sequela_403: 'Chronic intracerebral hemorrhage severity level 4',
    sequela_404: 'Chronic intracerebral hemorrhage severity level 3',
    sequela_405: 'Chronic intracerebral hemorrhage severity level 5',
    sequela_406: 'Mild heart failure due to hypertensive heart disease',
    sequela_407: 'Moderate heart failure due to hypertensive heart disease',
    sequela_408: 'Severe heart failure due to hypertensive heart disease',
    sequela_409: 'Acute myocarditis',
    sequela_413: 'Moderate endocarditis',
    sequela_414: 'Severe endocarditis',
    sequela_415: 'Mild heart failure due to endocarditis',
    sequela_416: 'Moderate heart failure due to endocarditis',
    sequela_417: 'Severe heart failure due to endocarditis',
    sequela_418: 'Mild heart failure due to other cardiovascular diseases',
    sequela_419: 'Moderate heart failure due to other cardiovascular diseases',
    sequela_420: 'Severe heart failure due to other cardiovascular diseases',
    sequela_421: 'Mild chronic obstructive pulmonary disease',
    sequela_422: 'Moderate chronic obstructive pulmonary disease',
    sequela_423: 'Mild silicosis',
    sequela_424: 'Moderate silicosis',
    sequela_425: 'Mild asbestosis',
    sequela_426: 'Moderate asbestosis',
    sequela_427: 'Mild coal workers pneumoconiosis',
    sequela_428: 'Moderate coal workers pneumoconiosis',
    sequela_429: 'Mild other pneumoconiosis',
    sequela_430: 'Moderate other pneumoconiosis',
    sequela_431: 'Controlled asthma',
    sequela_432: 'Partially controlled asthma',
    sequela_433: 'Uncontrolled asthma',
    sequela_434: 'Mild interstitial lung disease and pulmonary sarcoidosis',
    sequela_435: 'Moderate interstitial lung disease and pulmonary sarcoidosis',
    sequela_436: 'Other chronic respiratory diseases',
    sequela_445: 'Appendicitis',
    sequela_446: 'Paralytic ileus and intestinal obstruction',
    sequela_448: 'Vascular intestinal disorders',
    sequela_449: 'Gallbladder and biliary diseases',
    sequela_451: 'Other digestive diseases',
    sequela_452: "Mild Alzheimer's disease and other dementias",
    sequela_453: "Moderate Alzheimer's disease and other dementias",
    sequela_454: "Severe Alzheimer's disease and other dementias",
    sequela_455: "Mild Parkinson's disease",
    sequela_456: "Moderate Parkinson's disease",
    sequela_457: "Severe Parkinson's disease",
    sequela_458: 'Idiopathic, seizure-free, treated epilepsy',
    sequela_459: 'Idiopathic, less severe epilepsy',
    sequela_460: 'Idiopathic, severe epilepsy',
    sequela_461: 'Mild multiple sclerosis',
    sequela_462: 'Moderate multiple sclerosis',
    sequela_463: 'Severe multiple sclerosis',
    sequela_464: 'Other neurological disorders',
    sequela_465: 'Guillain-Barré syndrome due to other neurological disorders',
    sequela_466: 'Schizophrenia acute state',
    sequela_467: 'Schizophrenia residual state',
    sequela_468: 'Mild alcohol dependence',
    sequela_469: 'Moderate alcohol dependence',
    sequela_470: 'Severe alcohol dependence',
    sequela_471: 'Mild fetal alcohol syndrome',
    sequela_472: 'Moderate fetal alcohol syndrome',
    sequela_473: 'Severe fetal alcohol syndrome',
    sequela_474: 'Other drug use disorders',
    sequela_475: 'Mild major depressive disorder',
    sequela_476: 'Moderate major depressive disorder',
    sequela_477: 'Severe major depressive disorder',
    sequela_478: 'Bipolar disorder manic state',
    sequela_479: 'Bipolar disorder residual state',
    sequela_480: 'Mild anxiety disorders',
    sequela_481: 'Moderate anxiety disorders',
    sequela_482: 'Severe anxiety disorders',
    sequela_483: 'Anorexia nervosa',
    sequela_484: 'Bulimia nervosa',
    sequela_487: 'Borderline idiopathic developmental intellectual disability',
    sequela_488: 'Mild idiopathic developmental intellectual disability',
    sequela_489: 'Moderate idiopathic developmental intellectual disability',
    sequela_490: 'Severe idiopathic developmental intellectual disability',
    sequela_491: 'Profound idiopathic developmental intellectual disability',
    sequela_492: 'Mild other mental disorders',
    sequela_497: 'Acute glomerulonephritis',
    sequela_501: 'End-stage renal disease after transplant due to hypertension',
    sequela_502: 'End-stage renal disease on dialysis due to hypertension',
    sequela_504: 'End-stage renal disease after transplant due to glomerulonephritis',
    sequela_505: 'End-stage renal disease on dialysis due to glomerulonephritis',
    sequela_507: 'End-stage renal disease after transplant due to other and unspecified causes',
    sequela_508: 'End-stage renal disease on dialysis due to other and unspecified causes',
    sequela_510: 'Mild urinary tract infections',
    sequela_511: 'Moderate urinary tract infections',
    sequela_514: 'Idiopathic primary male infertility',
    sequela_515: 'Idiopathic secondary male infertility',
    sequela_516: 'Other urinary diseases',
    sequela_517: 'Primary infertility due to polycystic ovarian syndrome',
    sequela_518: 'Idiopathic primary female infertility',
    sequela_519: 'Idiopathic secondary female infertility',
    sequela_520: 'Mild abdominal pain due to endometriosis',
    sequela_521: 'Moderate abdominal pain due to endometriosis',
    sequela_522: 'Primary infertility due to endometriosis',
    sequela_523: 'Secondary infertility due to endometriosis',
    sequela_524: 'Abdominal pain due to premenstrual syndrome',
    sequela_525: 'Mild anemia due to menstrual disorders',
    sequela_526: 'Moderate anemia due to menstrual disorders',
    sequela_527: 'Severe anemia due to menstrual disorders',
    sequela_528: 'Mild heart failure due to thalassemias',
    sequela_529: 'Moderate heart failure due to thalassemias',
    sequela_530: 'Severe heart failure due to thalassemias',
    sequela_531: 'Mild anemia due to other hemoglobinopathies and hemolytic anemias',
    sequela_532: 'Moderate anemia due to other hemoglobinopathies and hemolytic anemias',
    sequela_533: 'Severe anemia due to other hemoglobinopathies and hemolytic anemias',
    sequela_534: 'Mild heart failure due to other hemoglobinopathies and hemolytic anemias',
    sequela_535: 'Moderate heart failure due to other hemoglobinopathies and hemolytic anemias',
    sequela_536: 'Severe heart failure due to other hemoglobinopathies and hemolytic anemias',
    sequela_537: 'Mild anemia due to endocrine, metabolic, blood, and immune disorders',
    sequela_538: 'Moderate anemia due to endocrine, metabolic, blood, and immune disorders',
    sequela_539: 'Severe anemia due to endocrine, metabolic, blood, and immune disorders',
    sequela_540: 'Mild heart failure due to endocrine, metabolic, blood, and immune disorders',
    sequela_541: 'Moderate heart failure due to endocrine, metabolic, blood, and immune disorders',
    sequela_542: 'Severe heart failure due to endocrine, metabolic, blood, and immune disorders',
    sequela_543: 'Mild rheumatoid arthritis',
    sequela_544: 'Moderate rheumatoid arthritis',
    sequela_545: 'Severe rheumatoid arthritis',
    sequela_546: 'Mild osteoarthritis of the hip',
    sequela_547: 'Moderate osteoarthritis of the hip',
    sequela_548: 'Severe osteoarthritis of the hip',
    sequela_549: 'Mild osteoarthritis of the knee',
    sequela_550: 'Moderate osteoarthritis of the knee',
    sequela_551: 'Severe osteoarthritis of the knee',
    sequela_552: 'Severe low back pain with leg pain',
    sequela_553: 'Severe low back pain without leg pain',
    sequela_554: 'Most severe low back pain with leg pain',
    sequela_555: 'Most severe low back pain without leg pain',
    sequela_556: 'Mild neck pain',
    sequela_557: 'Severe neck pain',
    sequela_558: 'Moderate neck pain',
    sequela_559: 'Most severe neck pain',
    sequela_560: 'Polyarticular gout',
    sequela_561: 'Other musculoskeletal disorders severity level 2',
    sequela_562: 'Other musculoskeletal disorders severity level 3',
    sequela_563: 'Other musculoskeletal disorders severity level 5',
    sequela_564: 'Other musculoskeletal disorders severity level 6',
    sequela_565: 'Other musculoskeletal disorders severity level 1',
    sequela_566: 'Other musculoskeletal disorders severity level 4',
    sequela_570: 'Congenital heart disease due to Turner syndrome',
    sequela_571: 'Primary infertility due to Turner syndrome',
    sequela_572: 'Borderline intellectual disability due to Klinefelter syndrome',
    sequela_573: 'Mild intellectual disability due to Klinefelter syndrome',
    sequela_574: 'Mild intellectual disability with infertility due to Klinefelter syndrome',
    sequela_576: 'Mild hearing loss due to other congenital anomalies',
    sequela_577: 'Mild hearing loss with ringing due to other congenital anomalies',
    sequela_578: 'Moderate hearing loss due to other congenital anomalies',
    sequela_579: 'Moderate hearing loss with ringing due to other congenital anomalies',
    sequela_580: 'Severe hearing loss with ringing due to other congenital anomalies',
    sequela_581: 'Severe hearing loss due to other congenital anomalies',
    sequela_582: 'Complete hearing loss due to other congenital anomalies',
    sequela_583: 'Complete hearing loss with ringing due to other congenital anomalies',
    sequela_584: 'Moderately severe hearing loss due to other congenital anomalies',
    sequela_585: 'Moderately severe hearing loss with ringing due to other congenital anomalies',
    sequela_586: 'Profound hearing loss due to other congenital anomalies',
    sequela_587: 'Profound hearing loss with ringing due to other congenital anomalies',
    sequela_588: 'Mild atopic dermatitis',
    sequela_589: 'Moderate atopic dermatitis',
    sequela_590: 'Severe atopic dermatitis',
    sequela_591: 'Mild psoriasis',
    sequela_592: 'Moderate psoriasis',
    sequela_593: 'Severe psoriasis',
    sequela_594: 'Impetigo',
    sequela_595: 'Abscess and other bacterial skin diseases',
    sequela_596: 'Scabies',
    sequela_597: 'Tinea capitis',
    sequela_598: 'Mild viral warts',
    sequela_599: 'Severe viral warts',
    sequela_601: 'Mild alopecia areata',
    sequela_602: 'Severe alopecia areata',
    sequela_603: 'Pruritus',
    sequela_604: 'Mild urticaria',
    sequela_605: 'Severe urticaria',
    sequela_606: 'Mild decubitus ulcer',
    sequela_607: 'Moderate decubitus ulcer',
    sequela_608: 'Severe decubitus ulcer',
    sequela_609: 'Moderate vision impairment due to glaucoma',
    sequela_610: 'Severe vision impairment due to glaucoma',
    sequela_611: 'Blindness due to glaucoma',
    sequela_612: 'Moderate vision impairment due to cataract',
    sequela_613: 'Severe vision impairment due to cataract',
    sequela_614: 'Blindness due to cataract',
    sequela_615: 'Moderate vision impairment due to macular degeneration',
    sequela_616: 'Severe vision impairment due to macular degeneration',
    sequela_617: 'Blindness due to macular degeneration',
    sequela_618: 'Moderate vision impairment due to uncorrected refractive error',
    sequela_619: 'Severe vision impairment due to uncorrected refractive error',
    sequela_620: 'Blindness due to uncorrected refractive error',
    sequela_621: 'Mild hearing loss due to age-related and other hearing loss',
    sequela_622: 'Mild hearing loss with ringing due to age-related and other hearing loss',
    sequela_623: 'Moderate hearing loss due to age-related and other hearing loss',
    sequela_624: 'Moderate hearing loss with ringing due to age-related and other hearing loss',
    sequela_625: 'Moderately severe hearing loss due to age-related and other hearing loss',
    sequela_626:
        'Moderately severe hearing loss with ringing due to age-related and other hearing loss',
    sequela_627: 'Severe hearing loss with ringing due to age-related and other hearing loss',
    sequela_628: 'Severe hearing loss due to age-related and other hearing loss',
    sequela_629: 'Profound hearing loss due to age-related and other hearing loss',
    sequela_630: 'Profound hearing loss with ringing due to age-related and other hearing loss',
    sequela_631: 'Complete hearing loss due to age-related and other hearing loss',
    sequela_632: 'Complete hearing loss with ringing due to age-related and other hearing loss',
    sequela_634: 'Moderate vision impairment due to other vision loss',
    sequela_635: 'Severe vision impairment due to other vision loss',
    sequela_636: 'Blindness due to other vision loss',
    sequela_640: 'Monocular distance vision loss due to pneumococcal meningitis',
    sequela_641: 'Monocular distance vision loss due to H influenzae type B meningitis',
    sequela_642: 'Monocular distance vision loss due to meningococcal meningitis',
    sequela_643: 'Monocular distance vision loss due to other bacterial meningitis',
    sequela_644: 'Bipolar disorder depressive state',
    sequela_645: 'Mild anemia due to B-thalassemia trait',
    sequela_646: 'Moderate anemia due to B-thalassemia trait',
    sequela_647: 'Severe anemia due to B-thalassemia trait',
    sequela_648: 'Mild anemia due to hemoglobin E trait',
    sequela_649: 'Moderate anemia due to hemoglobin E trait',
    sequela_650: 'Severe anemia due to hemoglobin E trait',
    sequela_651: 'Mild anemia due to sickle cell trait',
    sequela_652: 'Moderate anemia due to sickle cell trait',
    sequela_653: 'Severe anemia due to sickle cell trait',
    sequela_654: 'Mild anemia due to hemizygous G6PD trait',
    sequela_655: 'Moderate anemia due to hemizygous G6PD trait',
    sequela_656: 'Severe anemia due to hemizygous G6PD trait',
    sequela_657: 'Disfigurement due to basal cell carcinoma',
    sequela_658: 'Severe skin disease due to onchocerciasis',
    sequela_659: 'Mild contact dermatitis',
    sequela_660: 'Moderate contact dermatitis',
    sequela_661: 'Symptomatic seborrhoeic dermatitis',
    sequela_662: 'Pain due to caries of deciduous teeth',
    sequela_663: 'Pain due to caries of permanent teeth',
    sequela_664: 'Difficulty eating due to edentulism and severe tooth loss',
    sequela_665: 'Mild diarrheal diseases',
    sequela_666: 'Moderate diarrheal diseases',
    sequela_667: 'Severe diarrheal diseases',
    sequela_668: 'Guillain-Barré syndrome due to diarrheal diseases',
    sequela_669: 'Moderate lower respiratory infections',
    sequela_670: 'Severe lower respiratory infections',
    sequela_671: 'Guillain-Barré syndrome due to lower respiratory infections',
    sequela_672: 'Other fungal skin diseases',
    sequela_673: 'Mild skin disease without itch due to onchocerciasis',
    sequela_674: 'Severe skin disease without itch due to onchocerciasis',
    sequela_675: 'Infertility due to puerperal sepsis',
    sequela_676: 'Other hypertensive disorders of pregnancy',
    sequela_677: 'Long term sequelae of eclampsia',
    sequela_678: 'Very mild alcohol dependence',
    sequela_679: 'Mild amphetamine dependence',
    sequela_680: 'Moderate other mental disorders',
    sequela_681: 'Severe other mental disorders',
    sequela_682: 'Mild low back pain with leg pain',
    sequela_683: 'Mild low back pain without leg pain',
    sequela_684: 'Moderate low back pain with leg pain',
    sequela_685: 'Moderate low back pain without leg pain',
    sequela_686: 'Mild cannabis dependence',
    sequela_687: 'Mild cocaine dependence',
    sequela_688: 'Congenital heart disease with infertility due to Turner syndrome',
    sequela_689: 'Neurocysticercosis with epilepsy',
    sequela_690: 'Mild opioid dependence',
    sequela_691: 'Borderline intellectual disability with infertility due to Klinefelter syndrome',
    sequela_700: 'Depression due to premenstrual syndrome',
    sequela_701:
        'Moderate motor plus cognitive impairment with blindness due to hemolytic disease and other neonatal jaundice',
    sequela_702:
        'Moderate motor plus cognitive impairment with blindness due to neonatal preterm birth complications 28-32wks',
    sequela_703:
        'Moderate motor plus cognitive impairment with blindness due to neonatal preterm birth complications <28wks',
    sequela_704:
        'Moderate motor plus cognitive impairment with blindness due to neonatal preterm birth complications 32-36wks',
    sequela_705:
        'Moderate motor plus cognitive impairment with blindness due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_706: 'Moderate motor plus cognitive impairment with blindness due to neonatal tetanus',
    sequela_707:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_708:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to neonatal preterm birth complications <28wks',
    sequela_709:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_710:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to neonatal tetanus',
    sequela_711:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_712:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_713:
        'Moderate motor plus cognitive impairment with epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_714: 'Moderate motor plus cognitive impairment with epilepsy due to neonatal tetanus',
    sequela_715:
        'Moderate motor plus cognitive impairment with epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_716:
        'Moderate motor plus cognitive impairment with epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_717:
        'Moderate motor plus cognitive impairment with epilepsy due to neonatal preterm birth complications <28wks',
    sequela_718:
        'Moderate motor plus cognitive impairment with epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_719: 'Severe motor plus cognitive impairment with blindness due to neonatal tetanus',
    sequela_720:
        'Severe motor plus cognitive impairment with blindness due to neonatal preterm birth complications 28-32wks',
    sequela_721:
        'Severe motor plus cognitive impairment with blindness due to neonatal preterm birth complications 32-36wks',
    sequela_722:
        'Severe motor plus cognitive impairment with blindness due to hemolytic disease and other neonatal jaundice',
    sequela_723:
        'Severe motor plus cognitive impairment with blindness due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_724:
        'Severe motor plus cognitive impairment with blindness due to neonatal preterm birth complications <28wks',
    sequela_725:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_726:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to neonatal preterm birth complications <28wks',
    sequela_727:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_728:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_729:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_730:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to neonatal tetanus',
    sequela_731:
        'Severe motor plus cognitive impairment with epilepsy due to neonatal preterm birth complications <28wks',
    sequela_732:
        'Severe motor plus cognitive impairment with epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_733:
        'Severe motor plus cognitive impairment with epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_734:
        'Severe motor plus cognitive impairment with epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_735:
        'Severe motor plus cognitive impairment with epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_736: 'Severe motor plus cognitive impairment with epilepsy due to neonatal tetanus',
    sequela_737: 'Moderate motor impairment due to neonatal tetanus',
    sequela_738: 'Moderate motor impairment due to hemolytic disease and other neonatal jaundice',
    sequela_739: 'Moderate motor impairment due to neonatal preterm birth complications 28-32wks',
    sequela_740:
        'Moderate motor impairment due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_741: 'Moderate motor impairment due to neonatal preterm birth complications <28wks',
    sequela_742: 'Moderate motor impairment due to neonatal preterm birth complications 32-36wks',
    sequela_743:
        'Moderate motor impairment with blindness due to neonatal preterm birth complications <28wks',
    sequela_744:
        'Moderate motor impairment with blindness due to neonatal preterm birth complications 28-32wks',
    sequela_745:
        'Moderate motor impairment with blindness due to neonatal preterm birth complications 32-36wks',
    sequela_746: 'Moderate motor impairment with blindness due to neonatal tetanus',
    sequela_747:
        'Moderate motor impairment with blindness due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_748:
        'Moderate motor impairment with blindness due to hemolytic disease and other neonatal jaundice',
    sequela_749:
        'Moderate motor impairment with blindness and epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_750:
        'Moderate motor impairment with blindness and epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_751:
        'Moderate motor impairment with blindness and epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_752:
        'Moderate motor impairment with blindness and epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_753:
        'Moderate motor impairment with blindness and epilepsy due to neonatal preterm birth complications <28wks',
    sequela_754: 'Moderate motor impairment with blindness and epilepsy due to neonatal tetanus',
    sequela_755:
        'Moderate motor impairment with epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_756: 'Moderate motor impairment with epilepsy due to neonatal tetanus',
    sequela_757:
        'Moderate motor impairment with epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_758:
        'Moderate motor impairment with epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_759:
        'Moderate motor impairment with epilepsy due to neonatal preterm birth complications <28wks',
    sequela_760:
        'Moderate motor impairment with epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_761:
        'Severe motor impairment due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_762:
        'Severe motor impairment severe due to hemolytic disease and other neonatal jaundice',
    sequela_763: 'Severe motor impairment due to neonatal preterm birth complications <28wks',
    sequela_764: 'Severe motor impairment due to neonatal preterm birth complications 32-36wks',
    sequela_765: 'Severe motor impairment due to neonatal preterm birth complications 28-32wks',
    sequela_766: 'Severe motor impairment due to neonatal tetanus',
    sequela_767:
        'Severe motor impairment with blindness due to neonatal preterm birth complications 28-32wks',
    sequela_768: 'Severe motor impairment with blindness due to neonatal tetanus',
    sequela_769:
        'Severe motor impairment with blindness due to hemolytic disease and other neonatal jaundice',
    sequela_770:
        'Severe motor impairment with blindness due to neonatal preterm birth complications <28wks',
    sequela_771:
        'Severe motor impairment with blindness due to neonatal preterm birth complications 32-36wks',
    sequela_772:
        'Severe motor impairment with blindness due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_773: 'Severe motor impairment with blindness and epilepsy due to neonatal tetanus',
    sequela_774:
        'Severe motor impairment with blindness and epilepsy due to neonatal preterm birth complications <28wks',
    sequela_775:
        'Severe motor impairment with blindness and epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_776:
        'Severe motor impairment with blindness and epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_777:
        'Severe motor impairment with blindness and epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_778:
        'Severe motor impairment with blindness and epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_779:
        'Severe motor impairment with epilepsy due to neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_780:
        'Severe motor impairment with epilepsy due to neonatal preterm birth complications 32-36wks',
    sequela_781: 'Severe motor impairment with epilepsy due to neonatal tetanus',
    sequela_782:
        'Severe motor impairment with epilepsy due to neonatal preterm birth complications <28wks',
    sequela_783:
        'Severe motor impairment with epilepsy due to neonatal preterm birth complications 28-32wks',
    sequela_784:
        'Severe motor impairment with epilepsy due to hemolytic disease and other neonatal jaundice',
    sequela_785: 'Mild motor impairment due to neonatal tetanus',
    sequela_786: 'Mild motor plus cognitive impairments due to neonatal tetanus',
    sequela_787: 'Epilepsy due to echinococcosis',
    sequela_788: 'Symptomatic genital herpes',
    sequela_789: 'Other hemoglobinopathies and hemolytic anemias residual',
    sequela_793: 'Mild behavioral problems due to encephalitis',
    sequela_794: 'Mild motor impairment due to long term due to encephalitis',
    sequela_795: 'Mild motor plus cognitive impairments due to encephalitis',
    sequela_796: 'Borderline intellectual disability due to encephalitis',
    sequela_797: 'Monocular distance vision loss due to encephalitis',
    sequela_798: 'Mild intellectual disability due to encephalitis',
    sequela_799: 'Moderate motor impairment due to encephalitis',
    sequela_800: 'Severe motor impairment due to encephalitis',
    sequela_801: 'Moderate motor plus cognitive impairments due to encephalitis',
    sequela_802: 'Severe motor plus cognitive impairments due to encephalitis',
    sequela_803: 'Epilepsy due to encephalitis',
    sequela_804: 'Severe opioid dependence',
    sequela_805: 'Severe cocaine dependence',
    sequela_806: 'Severe amphetamine dependence',
    sequela_807: 'Severe cannabis dependence',
    sequela_808: 'Other sexually transmitted diseases residual',
    sequela_809: 'Asymptomatic atrial fibrillation and flutter',
    sequela_810: 'Symptomatic attention-deficit/hyperactivity disorder',
    sequela_811: 'Attention-deficit/hyperactivity disorder, currently without symptoms',
    sequela_812: 'Asymptomatic alcohol dependence',
    sequela_813: 'Asymptomatic fetal alcohol syndrome',
    sequela_814: 'Anxiety disorders, currently without symptoms',
    sequela_815: 'Symptomatic conduct disorder',
    sequela_816: 'Conduct disorder, currently without symptoms',
    sequela_817: 'Asymptomatic cannabis dependence',
    sequela_818: 'Asymptomatic opioid dependence',
    sequela_819: 'Asymptomatic cocaine dependence',
    sequela_820: 'Symptomatic dysthymia',
    sequela_821: 'Dysthymia, currently without symptoms',
    sequela_822: 'Major depressive disorder, currently without symptoms',
    sequela_823: 'Symptomatic episodes of gout',
    sequela_824: 'Asymptomatic gout',
    sequela_827: 'Symptomatic tension-type headache',
    sequela_828: 'Asymptomatic tension-type headache',
    sequela_829: 'Severe infectious complications due to chronic otitis media',
    sequela_830: 'Asymptomatic asthma',
    sequela_831: 'Asymptomatic genital herpes',
    sequela_832: 'Asymptomatic endometriosis',
    sequela_833: 'Asymptomatic amphetamine dependence',
    sequela_834: 'Cirrhosis and other chronic liver diseases due to alcohol, decompensated',
    sequela_835: 'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated',
    sequela_836: 'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated',
    sequela_837: 'Cirrhosis and other chronic liver diseases due to other cause, decompensated',
    sequela_838: 'Isolated congenital heart disease due to Down syndrome',
    sequela_839: 'Asymptomatic other cardiovascular diseases',
    sequela_840: 'Mild other cardiovascular diseases',
    sequela_841: 'Moderate other cardiovascular diseases',
    sequela_842: 'Severe other cardiovascular diseases',
    sequela_843: 'Asymptomatic other gynecological disorders',
    sequela_844: 'Mild other gynecological disorders',
    sequela_845: 'Moderate other gynecological disorders',
    sequela_846: 'Severe other gynecological disorders',
    sequela_847: 'Blindness due to H influenzae type B meningitis',
    sequela_848: 'Blindness due to meningococcal meningitis',
    sequela_849: 'Blindness due to other bacterial meningitis',
    sequela_850: 'Blindness due to pneumococcal meningitis',
    sequela_851: 'Other mental disorders, currently without symptoms',
    sequela_853: 'Asymptomatic premenstrual syndrome',
    sequela_854: 'Abdominal pain and depression due to premenstrual syndrome',
    sequela_855: 'Asymptomatic polycystic ovarian syndrome',
    sequela_856: 'Hirsutism due to polycystic ovarian syndrome',
    sequela_857: 'Hirsutism and primary infertility due to polycystic ovarian syndrome',
    sequela_858: 'Asymptomatic genital prolapse',
    sequela_859: 'Abdominal pain due to genital prolapse',
    sequela_860: 'Stress incontinence due to genital prolapse',
    sequela_861: 'Abdominal pain and stress incontinence due to genital prolapse',
    sequela_862: 'Asymptomatic acute hepatitis A',
    sequela_863: 'Asymptomatic acute hepatitis B',
    sequela_864: 'Asymptomatic acute hepatitis C',
    sequela_865: 'Asymptomatic acute hepatitis E',
    sequela_866: 'Asymptomatic retinopathy of prematurity',
    sequela_867: 'Blindness due to retinopathy of prematurity',
    sequela_868: 'Mild motor impairment due to neonatal preterm birth complications <28wks',
    sequela_869: 'Mild motor impairment due to neonatal preterm birth complications 28-32wks',
    sequela_870: 'Mild motor impairment due to neonatal preterm birth complications 32-36wks',
    sequela_871:
        'Mild motor plus cognitive impairments due to neonatal preterm birth complications <28wks',
    sequela_872:
        'Mild motor plus cognitive impairments due to neonatal preterm birth complications 28-32wks',
    sequela_873:
        'Mild motor plus cognitive impairments due to neonatal preterm birth complications 32-36wks',
    sequela_874: 'Blindness due to encephalitis',
    sequela_875: 'Blindness due to onchocerciasis',
    sequela_876: 'Moderate vision impairment due to onchocerciasis',
    sequela_877: 'Severe vision impairment due to onchocerciasis',
    sequela_878: 'Mild abdominal pain and primary infertility due to endometriosis',
    sequela_879: 'Moderate abdominal pain and primary infertility due to endometriosis',
    sequela_880: 'Severe abdominal pain and primary infertility due to endometriosis',
    sequela_881: 'Mild abdominal pain and secondary infertility due to endometriosis',
    sequela_882: 'Moderate abdominal pain and secondary infertility due to endometriosis',
    sequela_883: 'Severe abdominal pain and secondary infertility due to endometriosis',
    sequela_884: 'Moderate motor impairment due to malaria',
    sequela_885: 'Moderate motor impairment with blindness due to malaria',
    sequela_886: 'Moderate motor impairment with epilepsy due to malaria',
    sequela_887: 'Moderate motor impairment with blindness and epilepsy due to malaria',
    sequela_888: 'Moderate motor plus cognitive impairment with blindness due to malaria',
    sequela_889: 'Moderate motor plus cognitive impairment with epilepsy due to malaria',
    sequela_890:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to malaria',
    sequela_891: 'Severe motor impairment due to malaria',
    sequela_892: 'Severe motor impairment with blindness due to malaria',
    sequela_893: 'Severe motor impairment with epilepsy due to malaria',
    sequela_894: 'Severe motor impairment with blindness and epilepsy due to malaria',
    sequela_895: 'Severe motor plus cognitive impairment with blindness due to malaria',
    sequela_896: 'Severe motor plus cognitive impairment with epilepsy due to malaria',
    sequela_897:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to malaria',
    sequela_898: 'Asymptomatic other skin and subcutaneous diseases',
    sequela_899: 'Symptomatic other skin and subcutaneous diseases',
    sequela_900: 'Mild molluscum contagiosum',
    sequela_901: 'Severe molluscum contagiosum',
    sequela_902: 'Chronic hepatitis B without cirrhosis',
    sequela_903: 'Chronic hepatitis C without cirrhosis',
    sequela_904: 'Asymptomatic endocrine, metabolic, blood, and immune disorders',
    sequela_905: 'Mild endocrine, metabolic, blood, and immune disorders',
    sequela_906: 'Moderate endocrine, metabolic, blood, and immune disorders',
    sequela_907: 'Severe endocrine, metabolic, blood, and immune disorders',
    sequela_908: 'Heavy clonorchiasis due to food-borne trematodiases',
    sequela_909: 'Heavy fascioliasis due to food-borne trematodiases',
    sequela_910: 'Heavy intestinal fluke infection due to food-borne trematodiases',
    sequela_911: 'Heavy opisthorchiasis due to food-borne trematodiases',
    sequela_913: 'Symptomatic atrial fibrillation and flutter',
    sequela_914: 'Asymptomatic Turner syndrome',
    sequela_915: 'Moderate vision impairment due to retinopathy of prematurity',
    sequela_916: 'Severe vision impairment due to retinopathy of prematurity',
    sequela_917: 'Mild chlamydial infection',
    sequela_918: 'Asymptomatic chlamydial infection',
    sequela_919: 'Mild gonococcal infection',
    sequela_920: 'Asymptomatic gonococcal infection',
    sequela_921: 'Acute trichomoniasis infection',
    sequela_922: 'Asymptomatic trichomoniasis infection',
    sequela_923: 'Disfigurement level 1 due to orofacial clefts',
    sequela_924: 'Disfigurement level 2 due to orofacial clefts',
    sequela_925: 'Disfigurement level 2 and speech problems due to orofacial clefts',
    sequela_926: 'Asymptomatic orofacial clefts',
    sequela_929: 'Asymptomatic chronic obstructive pulmonary disease',
    sequela_930: 'Asymptomatic Down syndrome',
    sequela_931: 'Asymptomatic other chromosomal abnormalities',
    sequela_932: 'Primary infertility due to Klinefelter syndrome',
    sequela_933: 'Asymptomatic Klinefelter syndrome',
    sequela_934: 'Isolated congenital heart disease due to other chromosomal abnormalities',
    sequela_935: 'Asymptomatic Chagas disease',
    sequela_936: 'Chronic periodontal diseases',
    sequela_937: 'Puerperal sepsis',
    sequela_938: 'Other maternal infections',
    sequela_939: 'Hirsutism and secondary infertility due to polycystic ovarian syndrome',
    sequela_940: 'Secondary infertility due to polycystic ovarian syndrome',
    sequela_941: 'Severe abdominal pain due to endometriosis',
    sequela_942: 'Moderate infection due to initial genital herpes episode',
    sequela_943: 'Asymptomatic caries of deciduous teeth',
    sequela_944: 'Asymptomatic caries of permanent teeth',
    sequela_945: 'Asymptomatic edentulism and severe tooth loss',
    sequela_946: 'Asymptomatic chronic ischemic stroke',
    sequela_947: 'Asymptomatic chronic intracerebral hemorrhage',
    sequela_948: 'Asymptomatic silicosis',
    sequela_949: 'Asymptomatic asbestosis',
    sequela_950: 'Asymptomatic coal workers pneumoconiosis',
    sequela_951: 'Asymptomatic other pneumoconiosis',
    sequela_952: 'Asymptomatic interstitial lung disease and pulmonary sarcoidosis',
    sequela_953: 'Asymptomatic angina due to ischemic heart disease',
    sequela_954: 'Ulcerative colitis',
    sequela_955: "Crohn's disease",
    sequela_956: 'Asymptomatic onchocerciasis',
    sequela_957: 'Asymptomatic ascariasis',
    sequela_958: 'Asymptomatic trichuriasis',
    sequela_959: 'Asymptomatic clonorchiasis',
    sequela_960: 'Asymptomatic fascioliasis',
    sequela_961: 'Asymptomatic intestinal fluke infection',
    sequela_962: 'Asymptomatic opisthorchiasis',
    sequela_963: 'Asymptomatic paragonimiasis',
    sequela_964: 'Asymptomatic peripheral arterial disease',
    sequela_965: 'Asymptomatic benign prostatic hyperplasia',
    sequela_966: 'Symptomatic benign prostatic hyperplasia',
    sequela_967: 'Asymptomatic uterine fibroids',
    sequela_968: 'Asymptomatic other musculoskeletal disorders',
    sequela_969: 'Mild cellulitis',
    sequela_970: 'Severe cellulitis',
    sequela_971: 'Gastrointestinal bleeding due to typhoid',
    sequela_972: 'Vertigo with mild hearing loss due to chronic otitis media',
    sequela_973: 'Vertigo with mild hearing loss and ringing due to chronic otitis media',
    sequela_974: 'Asymptomatic hookworm disease',
    sequela_980: 'Mild heart failure due to severe chronic obstructive pulmonary disease',
    sequela_981: 'Moderate heart failure due to severe chronic obstructive pulmonary disease',
    sequela_982: 'Severe heart failure due to severe chronic obstructive pulmonary disease',
    sequela_983: 'Severe chronic obstructive pulmonary disease without heart failure',
    sequela_984: 'Mild heart failure due to severe silicosis',
    sequela_985: 'Moderate heart failure due to severe silicosis',
    sequela_986: 'Severe heart failure due to severe silicosis',
    sequela_987: 'Severe silicosis without heart failure',
    sequela_988: 'Mild heart failure due to severe asbestosis',
    sequela_989: 'Moderate heart failure due to severe asbestosis',
    sequela_990: 'Severe heart failure due to severe asbestosis',
    sequela_991: 'Severe asbestosis without heart failure',
    sequela_992: 'Mild heart failure due to severe coal workers pneumoconiosis',
    sequela_993: 'Moderate heart failure due to severe coal workers pneumoconiosis',
    sequela_994: 'Severe heart failure due to severe coal workers pneumoconiosis',
    sequela_995: 'Severe coal workers pneumoconiosis without heart failure',
    sequela_996: 'Mild heart failure due to severe other pneumoconiosis',
    sequela_997: 'Moderate heart failure due to severe other pneumoconiosis',
    sequela_998: 'Severe heart failure due to severe other pneumoconiosis',
    sequela_999: 'Severe other pneumoconiosis without heart failure',
    sequela_1000:
        'Mild heart failure due to severe interstitial lung disease and pulmonary sarcoidosis',
    sequela_1001:
        'Moderate heart failure due to severe interstitial lung disease and pulmonary sarcoidosis',
    sequela_1002:
        'Severe heart failure due to severe interstitial lung disease and pulmonary sarcoidosis',
    sequela_1003:
        'Severe interstitial lung disease and pulmonary sarcoidosis without heart failure',
    sequela_1016: 'Stage III chronic kidney disease and mild anemia due to hypertension',
    sequela_1017: 'Stage III chronic kidney disease and moderate anemia due to hypertension',
    sequela_1018: 'Stage III chronic kidney disease and severe anemia due to hypertension',
    sequela_1019: 'Stage III chronic kidney disease without anemia due to hypertension',
    sequela_1024: 'Stage III chronic kidney disease and mild anemia due to glomerulonephritis',
    sequela_1025: 'Stage III chronic kidney disease and moderate anemia due to glomerulonephritis',
    sequela_1026: 'Stage III chronic kidney disease and severe anemia due to glomerulonephritis',
    sequela_1027: 'Stage III chronic kidney disease without anemia due to glomerulonephritis',
    sequela_1032:
        'Stage III chronic kidney disease and mild anemia due to other and unspecified causes',
    sequela_1033:
        'Stage III chronic kidney disease and moderate anemia due to other and unspecified causes',
    sequela_1034:
        'Stage III chronic kidney disease and severe anemia due to other and unspecified causes',
    sequela_1035:
        'Stage III chronic kidney disease without anemia due to other and unspecified causes',
    sequela_1040: 'Asymptomatic ischemic heart disease following myocardial infarction',
    sequela_1041: 'Symptomatic claudication due to peripheral arterial disease',
    sequela_1046: 'Asymptomatic seborrhoeic dermatitis',
    sequela_1047: 'Asymptomatic contact dermatitis',
    sequela_1048: 'Mild other oral disorders',
    sequela_1049: 'Severe other oral disorders',
    sequela_1050: 'Asymptomatic B-thalassemia trait',
    sequela_1051: 'Asymptomatic hemoglobin E trait',
    sequela_1052: 'Asymptomatic sickle cell trait',
    sequela_1053: 'Asymptomatic hemizygous G6PD trait',
    sequela_1054: 'Mild hearing loss due to chronic otitis media',
    sequela_1055: 'Mild hearing loss with ringing due to chronic otitis media',
    sequela_1056: 'Asymptomatic malaria parasitemia (PfPR)',
    sequela_1057: 'Mild anemia due to malaria parasitemia (PfPR)',
    sequela_1058: 'Moderate anemia due to malaria parasitemia (PfPR)',
    sequela_1059: 'Severe anemia due to malaria parasitemia (PfPR)',
    sequela_1060: 'Beta-thalassemia major, severe infection with severe anemia ',
    sequela_1061: 'Beta-thalassemia major, with mild anemia ',
    sequela_1062: 'Beta-thalassemia major, with moderate anemia ',
    sequela_1063: 'Beta-thalassemia major, with severe anemia ',
    sequela_1064: 'Hemoglobin E/beta-thalassemia, severe infection with severe anemia ',
    sequela_1065: 'Hemoglobin E/beta-thalassemia, with mild anemia ',
    sequela_1066: 'Hemoglobin E/beta-thalassemia, with moderate anemia ',
    sequela_1067: 'Hemoglobin E/beta-thalassemia, with severe anemia ',
    sequela_1068: 'Hemoglobin H disease, severe infection with severe anemia ',
    sequela_1069: 'Hemoglobin H disease, with mild anemia ',
    sequela_1070: 'Hemoglobin H disease, with moderate anemia ',
    sequela_1071: 'Hemoglobin H disease, with severe anemia ',
    sequela_1072: 'Homozygous sickle cell and severe sickle cell/beta-thalassemia, without anemia',
    sequela_1073:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with vaso-occlusive crisis, without anemia',
    sequela_1074:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with vaso-occlusive crisis and severe anemia',
    sequela_1075:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with stroke and severe anemia',
    sequela_1076:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with stroke, without anemia',
    sequela_1077:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with vaso-occlusive crisis, stroke, and severe anemia',
    sequela_1078:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with vaso-occlusive crisis and stroke, without anemia',
    sequela_1079:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with mild anemia ',
    sequela_1080:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with moderate anemia ',
    sequela_1081:
        'Homozygous sickle cell and severe sickle cell/beta-thalassemia, with severe anemia ',
    sequela_1082: 'Hemoglobin SC disease, without anemia',
    sequela_1083: 'Hemoglobin SC disease, with vaso-occlusive crisis and severe anemia',
    sequela_1084: 'Hemoglobin SC disease, with vaso-occlusive crisis, without anemia',
    sequela_1085: 'Hemoglobin SC disease, with stroke and severe anemia',
    sequela_1086: 'Hemoglobin SC disease, with stroke, without anemia',
    sequela_1087: 'Hemoglobin SC disease, with vaso-occlusive crisis, stroke, and severe anemia',
    sequela_1088: 'Hemoglobin SC disease, with vaso-occlusive crisis and stroke, without anemia',
    sequela_1089: 'Hemoglobin SC disease, with mild anemia ',
    sequela_1090: 'Hemoglobin SC disease, with moderate anemia ',
    sequela_1091: 'Hemoglobin SC disease, with severe anemia ',
    sequela_1092: 'Mild sickle cell/beta-thalassemia, without anemia',
    sequela_1093: 'Mild sickle cell/beta-thalassemia, with vaso-occlusive crisis and severe anemia',
    sequela_1094: 'Mild sickle cell/beta-thalassemia, with vaso-occlusive crisis, without anemia',
    sequela_1095: 'Mild sickle cell/beta-thalassemia, with stroke and severe anemia',
    sequela_1096: 'Mild sickle cell/beta-thalassemia, with stroke, without anemia',
    sequela_1097:
        'Mild sickle cell/beta-thalassemia, with vaso-occlusive crisis, stroke, and severe anemia',
    sequela_1098:
        'Mild sickle cell/beta-thalassemia, with vaso-occlusive crisis and stroke, without anemia',
    sequela_1099: 'Mild sickle cell/beta-thalassemia, with mild anemia ',
    sequela_1100: 'Mild sickle cell/beta-thalassemia, with moderate anemia ',
    sequela_1101: 'Mild sickle cell/beta-thalassemia, with severe anemia ',
    sequela_1102: 'Vertigo with moderate hearing loss due to chronic otitis media',
    sequela_1103: 'Vertigo with moderate hearing loss and ringing due to chronic otitis media',
    sequela_1104: 'Moderate hearing loss due to chronic otitis media',
    sequela_1105: 'Moderate hearing loss with ringing due to chronic otitis media',
    sequela_1106: 'Mild abdominal pain due to uterine fibroids, with mild anemia ',
    sequela_1107: 'Mild abdominal pain due to uterine fibroids, with moderate anemia ',
    sequela_1108: 'Mild abdominal pain due to uterine fibroids, with severe anemia ',
    sequela_1109: 'Mild abdominal pain due to uterine fibroids, without anemia ',
    sequela_1112: 'Asymptomatic yellow fever',
    sequela_1113: 'Hemoglobin H disease, without anemia',
    sequela_1114: 'Beta-thalassemia major, without anemia',
    sequela_1115: 'Hemoglobin E/Beta-thalassemia, without anemia',
    sequela_1116: 'Rheumatic heart disease, without heart failure ',
    sequela_1117: 'Mild heart failure due to rheumatic heart disease',
    sequela_1118: 'Moderate heart failure due to rheumatic heart disease',
    sequela_1119: 'Severe heart failure due to rheumatic heart disease',
    sequela_1120: 'Mild anemia due to G6PD deficiency',
    sequela_1121: 'Moderate anemia due to G6PD deficiency',
    sequela_1122: 'Severe anemia due to G6PD deficiency',
    sequela_1123: 'Mild heart failure due to G6PD deficiency',
    sequela_1124: 'Moderate heart failure due to G6PD deficiency',
    sequela_1125: 'Severe heart failure due to G6PD deficiency',
    sequela_1126: 'Asymptomatic G6PD deficiency',
    sequela_1135: 'Asymptomatic gallbladder and biliary diseases',
    sequela_1143: 'Moderate vision impairment due to pneumococcol meningitis',
    sequela_1144: 'Severe vision impairment due to pneumococcol meningitis',
    sequela_1145: 'Moderate vision impairment due to H influenza type B meningitis',
    sequela_1146: 'Severe vision impairment due to H influenza type B meningitis',
    sequela_1147: 'Moderate vision impairment due to meningococcal meningitis',
    sequela_1148: 'Severe vision impairment due to meningococcal meningitis',
    sequela_1149: 'Moderate vision impairment due to other bacterial meningitis',
    sequela_1150: 'Severe vision impairment due to other bacterial meningitis',
    sequela_1151: 'Moderate vision impairment due to encephalitis',
    sequela_1152: 'Severe vision impairment due to encephalitis',
    sequela_1153:
        'Mild motor impairment, mild respiratory problems, and speech problems due to motor neuron disease',
    sequela_1154:
        'Mild motor impairment, moderate respiratory problems, and speech problems due to motor neuron disease',
    sequela_1155:
        'Mild motor impairment, severe respiratory problems and speech problems due to motor neuron disease',
    sequela_1156: 'Mild motor impairment and speech problems due to motor neuron disease',
    sequela_1157:
        'Moderate motor impairment, mild respiratory problems, and speech problems due to motor neuron disease',
    sequela_1158:
        'Moderate motor impairment, moderate respiratory problems, and speech problems due to motor neuron disease',
    sequela_1159:
        'Moderate motor impairment, severe respiratory problems, and speech problems due to motor neuron disease',
    sequela_1160:
        'Severe motor impairment, mild respiratory problems, and speech problems due to motor neuron disease',
    sequela_1161:
        'Severe motor impairment, moderate respiratory problems, and speech problems due to motor neuron disease',
    sequela_1162:
        'Severe motor impairment, severe respiratory problems, and speech problems due to motor neuron disease',
    sequela_1163: 'Mild motor impairment and mild respiratory problems due to motor neuron disease',
    sequela_1164:
        'Mild motor impairment and severe respiratory problems due to motor neuron disease',
    sequela_1165:
        'Moderate motor impairment and mild respiratory problems due to motor neuron disease',
    sequela_1166:
        'Moderate motor impairment and moderate respiratory problems due to motor neuron disease',
    sequela_1167:
        'Moderate motor impairment and severe respiratory problems due to motor neuron disease',
    sequela_1168:
        'Severe motor impairment and mild respiratory problems due to motor neuron disease',
    sequela_1169:
        'Severe motor impairment and moderate respiratory problems due to motor neuron disease',
    sequela_1170:
        'Severe motor impairment and severe respiratory problems due to motor neuron disease',
    sequela_1171: 'Moderate motor impairment and speech problems due to motor neuron disease',
    sequela_1172: 'Severe motor impairment and speech problems due to motor neuron disease',
    sequela_1173: 'Mild motor impairment due to motor neuron disease',
    sequela_1174: 'Moderate motor impairment due to motor neuron disease',
    sequela_1175: 'Severe motor impairment due to motor neuron disease',
    sequela_1176: 'Mild respiratory problems and speech problems due to motor neuron disease',
    sequela_1177: 'Moderate respiratory problems and speech problems due to motor neuron disease',
    sequela_1178: 'Severe respiratory problems and speech problems due to motor neuron disease',
    sequela_1179: 'Mild respiratory problems due to motor neuron disease',
    sequela_1180: 'Moderate respiratory problems due to motor neuron disease',
    sequela_1181: 'Severe respiratory problems due to motor neuron disease',
    sequela_1182: 'Speech problems due to motor neuron disease',
    sequela_1183: 'Diagnosis of motor neuron disease',
    sequela_1184: 'Ebola cases',
    sequela_1185: 'Post-Ebola chronic fatigue syndrome',
    sequela_1186: 'Diagnosis and primary therapy phase of acute lymphoid leukemia',
    sequela_1187: 'Diagnosis and primary therapy phase of acute myeloid leukemia',
    sequela_1188: 'Diagnosis and primary therapy phase of chronic lymphoid leukemia',
    sequela_1189: 'Diagnosis and primary therapy phase of chronic myeloid leukemia',
    sequela_1190: 'Controlled phase of acute lymphoid leukemia',
    sequela_1191: 'Controlled phase of acute myeloid leukemia',
    sequela_1192: 'Controlled phase of chronic lymphoid leukemia',
    sequela_1193: 'Controlled phase of chronic myeloid leukemia',
    sequela_1194: 'Metastatic phase of acute lymphoid leukemia',
    sequela_1195: 'Metastatic phase of acute myeloid leukemia',
    sequela_1196: 'Metastatic phase of chronic lymphoid leukemia',
    sequela_1197: 'Metastatic phase of chronic myeloid leukemia',
    sequela_1198: 'Terminal phase of acute lymphoid leukemia',
    sequela_1199: 'Terminal phase of acute myeloid leukemia',
    sequela_1200: 'Terminal phase of chronic lymphoid leukemia',
    sequela_1201: 'Terminal phase of chronic myeloid leukemia',
    sequela_1202: 'Asymptomatic early syphilis infection',
    sequela_1203: 'Mild early syphilis infection',
    sequela_1212: 'Borderline intellectual disability due to Down syndrome',
    sequela_1213: 'Mild intellectual disability due to Down syndrome',
    sequela_1214: 'Moderate intellectual disability due to Down syndrome',
    sequela_1215: 'Severe intellectual disability due to Down syndrome',
    sequela_1216: 'Profound intellectual disability due to Down syndrome',
    sequela_1217:
        'Borderline intellectual disability with congenital heart disease due to Down syndrome',
    sequela_1218: 'Mild intellectual disability with congenital heart disease due to Down syndrome',
    sequela_1219:
        'Moderate intellectual disability with congenital heart disease due to Down syndrome',
    sequela_1220:
        'Severe intellectual disability with congenital heart disease due to Down syndrome',
    sequela_1221:
        'Profound intellectual disability with congenital heart disease due to Down syndrome',
    sequela_1223: 'Borderline intellectual disability due to other chromosomal abnormalities',
    sequela_1224: 'Mild intellectual disability due to other chromosomal abnormalities',
    sequela_1225: 'Moderate intellectual disability due to other chromosomal abnormalities',
    sequela_1226: 'Severe intellectual disability due to other chromosomal abnormalities',
    sequela_1227: 'Profound intellectual disability due to other chromosomal abnormalities',
    sequela_1228:
        'Borderline intellectual disability with congenital heart disease due to other chromosomal abnormalities',
    sequela_1229:
        'Mild intellectual disability with congenital heart disease due to other chromosomal abnormalities',
    sequela_1230:
        'Moderate intellectual disability with congenital heart disease due to other chromosomal abnormalities',
    sequela_1231:
        'Severe intellectual disability with congenital heart disease due to other chromosomal abnormalities',
    sequela_1232:
        'Profound intellectual disability with congenital heart disease due to other chromosomal abnormalities',
    sequela_1234: 'Mild dementia due to Down syndrome',
    sequela_1235: 'Moderate dementia due to Down syndrome',
    sequela_1236: 'Severe dementia due to Down syndrome',
    sequela_1237: 'Congenital heart disease and mild dementia due to Down syndrome',
    sequela_1238: 'Congenital heart disease and moderate dementia due to Down syndrome',
    sequela_1239: 'Congenital heart disease and severe dementia due to Down syndrome',
    sequela_1240: 'Mild dementia due to other chromosomal abnormalities',
    sequela_1241: 'Moderate dementia due to other chromosomal abnormalities',
    sequela_1242: 'Severe dementia due to other chromosomal abnormalities',
    sequela_1243:
        'Congenital heart disease and mild dementia due to other chromosomal abnormalities',
    sequela_1244:
        'Congenital heart disease and moderate dementia due to other chromosomal abnormalities',
    sequela_1245:
        'Congenital heart disease and severe dementia due to other chromosomal abnormalities',
    sequela_1246: 'Asymptomatic neonatal preterm birth <28 weeks',
    sequela_1247: 'Asymptomatic neonatal preterm birth 28-<32 wks',
    sequela_1248: 'Asymptomatic neonatal preterm birth 32-<37wks',
    sequela_1249: 'Asymptomatic neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_1250: 'Asymptomatic neonatal sepsis and other neonatal infections',
    sequela_1251:
        'Mild motor plus cognitive impairments due to neonatal sepsis and other neonatal infections',
    sequela_1252: 'Mild motor impairment due to neonatal sepsis and other neonatal infections',
    sequela_1253: 'Moderate motor impairment due to neonatal sepsis and other neonatal infections',
    sequela_1254:
        'Moderate motor impairment with blindness due to neonatal sepsis and other neonatal infections',
    sequela_1255:
        'Moderate motor impairment with epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1256:
        'Moderate motor impairment with blindness and epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1257:
        'Moderate motor plus cognitive impairment with blindness due to neonatal sepsis and other neonatal infections',
    sequela_1258:
        'Moderate motor plus cognitive impairment with epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1259:
        'Moderate motor plus cognitive impairment with blindness and epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1260: 'Severe motor impairment due to neonatal sepsis and other neonatal infections',
    sequela_1261:
        'Severe motor impairment with blindness due to neonatal sepsis and other neonatal infections  ',
    sequela_1262:
        'Severe motor impairment with epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1263:
        'Severe motor impairment with blindness and epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1264:
        'Severe motor plus cognitive impairment with blindness due to neonatal sepsis and other neonatal infections',
    sequela_1265:
        'Severe motor plus cognitive impairment with epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1266:
        'Severe motor plus cognitive impairment with blindness and epilepsy due to neonatal sepsis and other neonatal infections',
    sequela_1267:
        'Borderline intellectual disability, mild dementia, and congenital heart disease due to Down syndrome',
    sequela_1268:
        'Mild intellectual disability, mild dementia, and congenital heart disease due to Down syndrome',
    sequela_1269:
        'Moderate intellectual disability, mild dementia, and congenital heart disease due to Down syndrome',
    sequela_1270:
        'Severe intellectual disability, mild dementia, and congenital heart disease due to Down syndrome',
    sequela_1271:
        'Profound intellectual disability, mild dementia, and congenital heart disease due to Down syndrome',
    sequela_1272:
        'Borderline intellectual disability, moderate dementia, and congenital heart disease due to Down syndrome',
    sequela_1273:
        'Mild intellectual disability, moderate dementia, and congenital heart disease due to Down syndrome',
    sequela_1274:
        'Moderate intellectual disability, moderate dementia, and congenital heart disease due to Down syndrome',
    sequela_1275:
        'Severe intellectual disability, moderate dementia, and congenital heart disease due to Down syndrome',
    sequela_1276:
        'Profound intellectual disability, moderate dementia, and congenital heart disease due to Down syndrome',
    sequela_1277:
        'Borderline intellectual disability, severe dementia, and congenital heart disease due to Down syndrome',
    sequela_1278:
        'Mild intellectual disability, severe dementia, and congenital heart disease due to Down syndrome',
    sequela_1279:
        'Moderate intellectual disability, severe dementia, and congenital heart disease due to Down syndrome',
    sequela_1280:
        'Severe intellectual disability, severe dementia, and congenital heart disease due to Down syndrome',
    sequela_1281:
        'Profound intellectual disability, severe dementia, and congenital heart disease due to Down syndrome',
    sequela_1282:
        'Borderline intellectual disability, mild dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1283:
        'Mild intellectual disability, mild dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1284:
        'Moderate intellectual disability, mild dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1285:
        'Severe intellectual disability, mild dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1286:
        'Profound intellectual disability, mild dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1287:
        'Borderline intellectual disability, moderate dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1288:
        'Mild intellectual disability, moderate dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1289:
        'Moderate intellectual disability, moderate dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1290:
        'Severe intellectual disability, moderate dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1291:
        'Profound intellectual disability, moderate dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1292:
        'Borderline intellectual disability, severe dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1293:
        'Mild intellectual disability, severe dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1294:
        'Moderate intellectual disability, severe dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1295:
        'Severe intellectual disability, severe dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1296:
        'Profound intellectual disability, severe dementia, and congenital heart disease due to other chromosomal abnormalities',
    sequela_1297: 'Profound intellectual disability and mild dementia due to Down syndrome',
    sequela_1298: 'Severe intellectual disability and mild dementia due to Down syndrome',
    sequela_1299: 'Moderate intellectual disability and mild dementia due to Down syndrome',
    sequela_1300: 'Mild intellectual disability and mild dementia due to Down syndrome',
    sequela_1301: 'Borderline intellectual disability and mild dementia due to Down syndrome',
    sequela_1302: 'Profound intellectual disability and moderate dementia due to Down syndrome',
    sequela_1303: 'Severe intellectual disability and moderate dementia due to Down syndrome',
    sequela_1304: 'Moderate intellectual disability and moderate dementia due to Down syndrome',
    sequela_1305: 'Mild intellectual disability and moderate dementia due to Down syndrome',
    sequela_1306: 'Borderline intellectual disability and moderate dementia due to Down syndrome',
    sequela_1307: 'Profound intellectual disability and severe dementia due to Down syndrome',
    sequela_1308: 'Severe intellectual disability and severe dementia due to Down syndrome',
    sequela_1309: 'Moderate intellectual disability and severe dementia due to Down syndrome',
    sequela_1310: 'Mild intellectual disability and severe dementia due to Down syndrome',
    sequela_1311: 'Borderline intellectual disability and severe dementia due to Down syndrome',
    sequela_1312:
        'Profound intellectual disability and mild dementia due to other chromosomal abnormalities',
    sequela_1313:
        'Severe intellectual disability and mild dementia due to other chromosomal abnormalities',
    sequela_1314:
        'Moderate intellectual disability and mild dementia due to other chromosomal abnormalities',
    sequela_1315:
        'Mild intellectual disability and mild dementia due to other chromosomal abnormalities',
    sequela_1316:
        'Borderline intellectual disability and mild dementia due to other chromosomal abnormalities',
    sequela_1317:
        'Profound intellectual disability and moderate dementia due to other chromosomal abnormalities',
    sequela_1318:
        'Severe intellectual disability and moderate dementia due to other chromosomal abnormalities',
    sequela_1319:
        'Moderate intellectual disability and moderate dementia due to other chromosomal abnormalities',
    sequela_1320:
        'Mild intellectual disability and moderate dementia due to other chromosomal abnormalities',
    sequela_1321:
        'Borderline intellectual disability and moderate dementia due to other chromosomal abnormalities',
    sequela_1322:
        'Profound intellectual disability and severe dementia due to other chromosomal abnormalities',
    sequela_1323:
        'Severe intellectual disability and severe dementia due to other chromosomal abnormalities',
    sequela_1324:
        'Moderate intellectual disability and severe dementia due to other chromosomal abnormalities',
    sequela_1325:
        'Mild intellectual disability and severe dementia due to other chromosomal abnormalities',
    sequela_1326:
        'Borderline intellectual disability and severe dementia due to other chromosomal abnormalities',
    sequela_1327: 'Autism spectrum disorders without intellectual disability',
    sequela_1328: 'Autism spectrum disorders with borderline intellectual disability',
    sequela_1329: 'Autism spectrum disorders with mild intellectual disability',
    sequela_1330: 'Autism spectrum disorders with moderate intellectual disability',
    sequela_1331: 'Autism spectrum disorders with severe intellectual disability',
    sequela_1332: 'Autism spectrum disorders with profound intellectual disability',
    sequela_1333: 'Asymptomatic acute other sense organ diseases',
    sequela_1334: 'Mild acute other sense organ diseases',
    sequela_1335: 'Moderate acute other sense organ diseases',
    sequela_1337: 'Asymptomatic chronic other sense organ diseases',
    sequela_1339: 'Mild chronic other sense organ diseases',
    sequela_1340: 'Moderate chronic other sense organ diseases',
    sequela_1341: 'Mild paragonimiasis due to food-borne trematodiases',
    sequela_1342: 'Moderate paragonimiasis due to food-borne trematodiases',
    sequela_1343: 'Severe paragonimiasis due to food-borne trematodiases',
    sequela_1346: 'Asymptomatic medication overuse headache due to migraine',
    sequela_1349: 'Symptomatic medication overuse headache due to migraine',
    sequela_1352: 'Asymptomatic medication overuse headache due to tension-type headache',
    sequela_1355: 'Symptomatic medication overuse headache due to tension-type headache',
    sequela_1370: 'Stage V chronic kidney disease untreated without anemia due to hypertension',
    sequela_1373: 'Stage V chronic kidney disease untreated and mild anemia due to hypertension',
    sequela_1376:
        'Stage V chronic kidney disease untreated and moderate anemia due to hypertension',
    sequela_1379: 'Stage V chronic kidney disease untreated and severe anemia due to hypertension',
    sequela_1382:
        'Stage V chronic kidney disease untreated without anemia due to glomerulonephritis',
    sequela_1385:
        'Stage V chronic kidney disease untreated and mild anemia due to glomerulonephritis',
    sequela_1388:
        'Stage V chronic kidney disease untreated and moderate anemia due to glomerulonephritis',
    sequela_1391:
        'Stage V chronic kidney disease untreated and severe anemia due to glomerulonephritis',
    sequela_1394:
        'Stage V chronic kidney disease untreated without anemia due to other and unspecified causes',
    sequela_1397:
        'Stage V chronic kidney disease untreated and mild anemia due to other and unspecified causes',
    sequela_1400:
        'Stage V chronic kidney disease untreated and moderate anemia due to other and unspecified causes',
    sequela_1403:
        'Stage V chronic kidney disease untreated and severe anemia due to other and unspecified causes',
    sequela_1418: 'Stage IV chronic kidney disease untreated without anemia due to hypertension',
    sequela_1421: 'Stage IV chronic kidney disease untreated and mild anemia due to hypertension',
    sequela_1424:
        'Stage IV chronic kidney disease untreated and moderate anemia due to hypertension',
    sequela_1427: 'Stage IV chronic kidney disease untreated and severe anemia due to hypertension',
    sequela_1430:
        'Stage IV chronic kidney disease untreated without anemia due to glomerulonephritis',
    sequela_1433:
        'Stage IV chronic kidney disease untreated and mild anemia due to glomerulonephritis',
    sequela_1436:
        'Stage IV chronic kidney disease untreated and moderate anemia due to glomerulonephritis',
    sequela_1439:
        'Stage IV chronic kidney disease untreated and severe anemia due to glomerulonephritis',
    sequela_1442:
        'Stage IV chronic kidney disease untreated without anemia due to other and unspecified causes',
    sequela_1445:
        'Stage IV chronic kidney disease untreated and mild anemia due to other and unspecified causes',
    sequela_1448:
        'Stage IV chronic kidney disease untreated and moderate anemia due to other and unspecified causes',
    sequela_1451:
        'Stage IV chronic kidney disease untreated and severe anemia due to other and unspecified causes',
    sequela_1454: 'Skin disfigurement due to Trypanosoma brucei gambiense',
    sequela_1457: 'Sleeping sickness due to Trypanosoma brucei gambiense',
    sequela_1460: 'Sleeping sickness due to Trypanosoma brucei rhodesiense',
    sequela_1463: 'Skin disfigurement due to Trypanosoma brucei rhodesiense',
    sequela_1481: 'Metastatic phase of other leukemia',
    sequela_1484: 'Diagnosis and primary therapy phase of other leukemia',
    sequela_1487: 'Terminal phase of other leukemia',
    sequela_1490: 'Controlled phase of other leukemia',
    sequela_1493: 'Drug-susceptible tuberculosis',
    sequela_1496: 'Multidrug-resistant tuberculosis without extensive drug resistance',
    sequela_1499: 'Extensively drug-resistant tuberculosis',
    sequela_1511: 'Acute Zika infection',
    sequela_1514: 'Guillain–Barré syndrome due to Zika infection',
    sequela_1517: 'Congenital Zika syndrome',
    sequela_1520: 'Asymptomatic Zika infection',
    sequela_1523: 'Mild heart failure due to myocarditis',
    sequela_1526: 'Moderate heart failure due to myocarditis',
    sequela_1529: 'Severe heart failure due to myocarditis',
    sequela_1532: 'Mild heart failure due to alcoholic cardiomyopathy',
    sequela_1535: 'Moderate heart failure due to alcoholic cardiomyopathy',
    sequela_1538: 'Severe heart failure due to alcoholic cardiomyopathy',
    sequela_1541: 'Mild heart failure due to other cardiomyopathy',
    sequela_1544: 'Moderate heart failure due to other cardiomyopathy',
    sequela_1547: 'Severe heart failure due to other cardiomyopathy',
    sequela_1550: 'Disfigurement level 1 due to polydactyly and syndactyly',
    sequela_1553: 'Disfigurement level 2 due to congenital limb deficiency',
    sequela_1556: 'Disfigurement level 2 with pain due to congenital limb deficiency',
    sequela_1565:
        'Disfigurement level 2 and mild motor impairment due to congenital limb deficiency',
    sequela_1568:
        'Disfigurement level 2 and moderate motor impairment due to congenital limb deficiency',
    sequela_1571:
        'Disfigurement level 2 with pain and mild motor impairment due to congenital limb deficiency',
    sequela_1574:
        'Disfigurement level 2 with pain and moderate motor impairment due to congenital limb deficiency',
    sequela_1577: 'Disfigurement level 2 due to other congenital musculoskeletal anomalies',
    sequela_1580:
        'Disfigurement level 2 with pain due to other congenital musculoskeletal anomalies',
    sequela_1589:
        'Disfigurement level 2 and mild motor impairment due to other congenital musculoskeletal anomalies',
    sequela_1592:
        'Disfigurement level 2 and moderate motor impairment due to other congenital musculoskeletal anomalies',
    sequela_1595:
        'Disfigurement level 2 with pain and mild motor impairment due to other congenital musculoskeletal anomalies',
    sequela_1598:
        'Disfigurement level 2 with pain and moderate motor impairment due to other congenital musculoskeletal anomalies',
    sequela_1601: 'Asymptomatic congenital diaphragmatic hernia',
    sequela_1604: 'Chronic abdominal pain due to congenital diaphragmatic hernia',
    sequela_1607: 'Disfigurement due to congenital diaphragmatic hernia',
    sequela_1610:
        'Mild chronic respiratory problems and breathlessness due to congenital diaphragmatic hernia',
    sequela_1613:
        'Developmental delay or mild intellectual disability due to congenital diaphragmatic hernia',
    sequela_1616: 'Chronic abdominal pain and disfigurement due to congenital diaphragmatic hernia',
    sequela_1619:
        'Chronic abdominal pain and mild chronic respiratory problems due to congenital diaphragmatic hernia',
    sequela_1622:
        'Chronic abdominal pain and developmental delay due to congenital diaphragmatic hernia',
    sequela_1625:
        'Disfigurement and mild chronic respiratory problems due to congenital diaphragmatic hernia',
    sequela_1628: 'Disfigurement and developmental delay due to congenital diaphragmatic hernia',
    sequela_1631:
        ' Mild chronic respiratory problems and developmental delay due to congenital diaphragmatic hernia',
    sequela_1634:
        'Chronic abdominal pain, disfigurement and  chronic respiratory problems due to congenital diaphragmatic hernia',
    sequela_1637:
        'Chronic abdominal pain, disfigurement and developmental delay due to congenital diaphragmatic hernia',
    sequela_1640:
        'Chronic abdominal pain, chronic respiratory problems and developmental delay due to congenital diaphragmatic hernia',
    sequela_1643:
        'Disfigurement, chronic respiratory problems and developmental delay due to congenital diaphragmatic hernia',
    sequela_1646:
        'Chronic abdominal pain, disfigurement, developmental delay and  chronic respiratory problems due to congenital diaphragmatic hernia',
    sequela_1649: 'Asymptomatic congenital atresia and/or stenosis of the digestive tract',
    sequela_1652:
        'Dysphagia or acid reflux due to congenital atresia and/or stenosis of the digestive tract',
    sequela_1655:
        'Chronic abdominal pain due to congenital atresia and/or stenosis of the digestive tract',
    sequela_1658:
        'Chronic respiratory problems including difficulty breaking and recurrent upper respiratory infections due to atresia and/or stenosis of the digestive tract',
    sequela_1661:
        'Chronic respiratory problems and dysphagia or acid reflux due to congenital atresia and/or stenosis of the digestive tract',
    sequela_1664:
        'Chronic respiratory problems and abdominal pain due to congenital atresia and/or stenosis of the digestive tract',
    sequela_1667:
        'Dysphagia or acid reflux and chronic abdominal pain due to congenital atresia and/or stenosis of the digestive tract',
    sequela_1670:
        'Dysphagia or acid reflux, chronic abdominal pain and chronic respiratory problems due to congenital atresia and/or stenosis of the digestive tract',
    sequela_1673: 'Asymptomatic congenital malformations of the abdominal wall after treatment',
    sequela_1676:
        'Disfigurement from scars following treatment for congenital malformations of the abdominal wall',
    sequela_1679: 'Constipation due to congenital malformations of the abdominal wall',
    sequela_1682: 'Chronic abdominal pain due to congenital malformations of the abdominal wall',
    sequela_1685:
        'Constipation and concern about scars due to congenital malformations of the abdominal wall',
    sequela_1688:
        'Chronic abdominal pain and concern about scars due to congenital malformations of the abdominal wall',
    sequela_1691:
        'Constipation and chronic abdominal pain due to congenital malformations of the abdominal wall',
    sequela_1694:
        'Constipation, chronic abdominal pain and concern about scars due to congenital malformations of the abdominal wall',
    sequela_1697: 'Asymptomatic other congenital malformations of the digestive tract',
    sequela_1700:
        'Acid reflux, dyspahgia, and/or constipation due to other congenital malformations of the digestive tract',
    sequela_1703:
        'Chronic abdominal pain and/or nausea due to other congenital malformations of the digestive tract',
    sequela_1706:
        'Chronic abdominal pain and/or nausea with acid reflux, dyspahgia, and/or constipation  due to other congenital malformations of the digestive tract',
    sequela_1709: 'Asymptomatic congenital genital anomalies',
    sequela_1712: 'Atypical genitalia due to congenital genital anomalies',
    sequela_1715: 'Primary infertility due to congenital genital anomalies',
    sequela_1718: 'Impotence due to congenital genital anomalies',
    sequela_1721:
        'Recurrent urinary tract infections or other abdominal issues due to congenital genital anomalies',
    sequela_1724:
        'Atypical genital and recurrent urinary tract infections and other abdominal issues due to congenital genital anomalies',
    sequela_1727: 'Atypical genitalia and primary infertility due to congenital genital anomalies',
    sequela_1730: 'Atypical genitalia and impotence due to congenital genital anomalies',
    sequela_1733:
        'Primary infertility and recurrent urinary tract infections or other abdominal issues due to congenital genital anomalies',
    sequela_1736:
        'Impotence and recurrent urinary tract infections or other abdominal issues due to congenital genital anomalies',
    sequela_1739: 'Infertility and impotence due to congenital genital anomalies',
    sequela_1742:
        'Atypical genitalia, recurrent urinary tract infections or other abdominal issues and infertility due to congenital genital anomalies',
    sequela_1745:
        'Atypical genitalia, recurrent urinary tract infections or other abdominal issues and impotence due to congenital genital anomalies',
    sequela_1748:
        'Atypical genitalia, infertility and impotence due to congenital genital anomalies',
    sequela_1751:
        'Infertility, impotence, and recurrent urinary tract infections or other abdominal issues and impotence due to congenital genital anomalies',
    sequela_1754:
        'Atypical genitalia, infertility, impotence, and recurrent urinary tract infections or other abdominal issues and impotence due to congenital genital anomalies',
    sequela_1757: 'Asymptomatic ventricular septal defect and atrial septal defect',
    sequela_1850: 'Asymptomatic congenital anomalies of the urinary tract',
    sequela_1853: 'Atypical genitalia due to congenital anomalies of the urinary tract',
    sequela_1856: 'Incontinence due to congenital anomalies of the urinary tract',
    sequela_1859: 'Impotence due to congenital anomalies of the urinary tract',
    sequela_1862:
        'Recurrent urinary tract infections or other abdominal issues due to congenital anomalies of the urinary tract',
    sequela_1865:
        'Atypical genital and recurrent urinary tract infections and other abdominal issues due to congenital anomalies of the urinary tract',
    sequela_1868:
        'Atypical genitalia and incontinence due to congenital anomalies of the urinary tract',
    sequela_1871:
        'Atypical genitalia and impotence due to congenital anomalies of the urinary tract',
    sequela_1874:
        'Incontinence and recurrent urinary tract infections or other abdominal issues due to congenital anomalies of the urinary tract',
    sequela_1877:
        'Impotence and recurrent urinary tract infections or other abdominal issues due to congenital anomalies of the urinary tract',
    sequela_1880: 'Incontinence and impotence due to congenital anomalies of the urinary tract',
    sequela_1883:
        'Atypical genitalia, recurrent urinary tract infections or other abdominal issues and incontinence due to congenital anomalies of the urinary tract',
    sequela_1886:
        'Atypical genitalia, recurrent urinary tract infections or other abdominal issues and impotence due to congenital anomalies of the urinary tract',
    sequela_1889:
        'Atypical genitalia, incontinence and impotence due to congenital anomalies of the urinary tract',
    sequela_1892:
        'Incontinence, impotence, and recurrent urinary tract infections or other abdominal issues and impotence due to congenital anomalies of the urinary tract',
    sequela_1895:
        'Atypical genitalia, incontinence, impotence, and recurrent urinary tract infections or other abdominal issues and impotence due to congenital anomalies of the urinary tract',
    sequela_1898: 'Severe motor and cognitive impairment due to Edward Syndrome or Patau Syndrome',
    sequela_1901:
        'Severe motor and cognitive impairment with congenital heart disease due to Edward Syndrome or Patau Syndrome',
    sequela_1904: 'Severe motor and cognitive impairment due to anencephaly',
    sequela_1907: 'Asymptomatic encephalocele following treatment',
    sequela_1910: 'Borderline intellectual disability due to encephalocele',
    sequela_1913: 'Mild intellectual disability due to encephalocele',
    sequela_1916: 'Moderate intellectual disability due to encephalocele',
    sequela_1919: 'Severe intellectual disability due to encephalocele',
    sequela_1922: 'Profound intellectual disability due to encephalocele',
    sequela_1925: 'Incontinence due to encephalocele',
    sequela_1928: 'Borderline intellectual disability and incontinence due to encephalocele',
    sequela_1931: 'Mild intellectual disability and incontinence due to encephalocele',
    sequela_1934: 'Moderate intellectual disability and incontinence due to encephalocele',
    sequela_1937: 'Severe intellectual disability and incontinence due to encephalocele',
    sequela_1940: 'Profound intellectual disability and incontinence due to encephalocele',
    sequela_1943: 'Mild motor impairment due to spina bifida',
    sequela_1946: 'Moderate motor impairment due to spina bifida',
    sequela_1949: 'Severe motor impairment due to spina bifida',
    sequela_1952:
        'Mild motor impairment and borderline intellectual disability due to spina bifida',
    sequela_1955:
        'Moderate motor impairment and borderline intellectual disability due to spina bifida',
    sequela_1958:
        'Severe motor impairment and borderline intellectual disability due to spina bifida',
    sequela_1961: 'Mild motor impairment and mild intellectual disability due to spina bifida',
    sequela_1964: 'Moderate motor impairment and mild intellectual disability due to spina bifida',
    sequela_1967: 'Severe motor impairment and mild intellectual disability due to spina bifida',
    sequela_1970: 'Mild motor impairment and moderate intellectual disability due to spina bifida',
    sequela_1973:
        'Moderate motor impairment and moderate intellectual disability due to spina bifida',
    sequela_1976:
        'Severe motor impairment and moderate intellectual disability due to spina bifida',
    sequela_1979: 'Mild motor impairment and severe intellectual disability due to spina bifida',
    sequela_1982:
        'Moderate motor impairment and severe intellectual disability due to spina bifida',
    sequela_1985: 'Severe motor impairment and severe intellectual disability due to spina bifida',
    sequela_1988:
        'Mild motor impairment, borderline intellectual disability and incontinence due to spina bifida',
    sequela_1991:
        'Moderate motor impairment, borderline intellectual disability and incontinence due to spina bifida',
    sequela_1994:
        'Severe motor impairment, borderline intellectual disability and incontinence due to spina bifida',
    sequela_1997:
        'Mild motor impairment, mild intellectual disability and incontinence due to spina bifida',
    sequela_2000:
        'Moderate motor impairment, mild intellectual disability and incontinence due to spina bifida',
    sequela_2003:
        'Severe motor impairment, mild intellectual disability and incontinence due to spina bifida',
    sequela_2006:
        'Mild motor impairment, moderate intellectual disability and incontinence due to spina bifida',
    sequela_2009:
        'Moderate motor impairment, moderate intellectual disability and incontinence due to spina bifida',
    sequela_2012:
        'Severe motor impairment, moderate intellectual disability and incontinence due to spina bifida',
    sequela_2015:
        'Mild motor impairment, severe intellectual disability and incontinence due to spina bifida',
    sequela_2018:
        'Moderate motor impairment, severe intellectual disability and incontinence due to spina bifida',
    sequela_2021:
        'Severe motor impairment, severe intellectual disability and incontinence due to spina bifida',
    sequela_2024: 'Mild motor impairment and incontinence due to spina bifida',
    sequela_2027: 'Moderate motor impairment and incontinence due to spina bifida',
    sequela_2030: 'Severe motor impairment and incontinence due to spina bifida',
    sequela_2033: 'Moderate wasting without edema',
    sequela_2036: 'Severe wasting with edema',
    sequela_2039: 'Mild disfigurement due to squamous cell carcinoma',
    sequela_2042: 'Moderate disfigurement due to squamous cell carcinoma',
    sequela_2045: 'Severe disfigurement due to squamous cell carcinoma',
    sequela_2048:
        'Neurological problems and cardiovascular complications due to adult tertiary syphilis',
    sequela_2051:
        'Severe disfigurement and cardiovascular complications due to adult tertiary syphilis',
    sequela_2054: 'Severe disfigurement and neurological problems due to adult tertiary syphilis',
    sequela_2057:
        'Severe disfigurement, neurological problems, and cardiovascular complications due to adult tertiary syphilis',
    sequela_2060: 'Mild motor impairment and profound intellectual disability due to spina bifida',
    sequela_2063:
        'Moderate motor impairment and profound intellectual disability due to spina bifida',
    sequela_2066:
        'Severe motor impairment and profound intellectual disability due to spina bifida',
    sequela_2069:
        'Mild motor impairment, profound intellectual disability and incontinence due to spina bifida',
    sequela_2072:
        'Moderate motor impairment, profound intellectual disability and incontinence due to spina bifida',
    sequela_2075:
        'Severe motor impairment, profound intellectual disability and incontinence due to spina bifida',
    sequela_2078: 'Mild motor impairment due to encephalocele',
    sequela_2081: 'Moderate motor impairment due to encephalocele',
    sequela_2084: 'Severe motor impairment due to encephalocele',
    sequela_2087: 'Mild motor impairment and incontinence due to encephalocele',
    sequela_2090: 'Moderate motor impairment and incontinence due to encephalocele',
    sequela_2093: 'Severe motor impairment and incontinence due to encephalocele',
    sequela_2096:
        'Mild motor impairment and borderline intellectual disability due to encephalocele',
    sequela_2099:
        'Moderate motor impairment and borderline intellectual disability due to encephalocele',
    sequela_2102:
        'Severe motor impairment and borderline intellectual disability due to encephalocele',
    sequela_2105: 'Mild motor impairment and mild intellectual disability due to encephalocele',
    sequela_2108: 'Moderate motor impairment and mild intellectual disability due to encephalocele',
    sequela_2111: 'Severe motor impairment and mild intellectual disability due to encephalocele',
    sequela_2114: 'Mild motor impairment and moderate intellectual disability due to encephalocele',
    sequela_2117:
        'Moderate motor impairment and moderate intellectual disability due to encephalocele',
    sequela_2120:
        'Severe motor impairment and moderate intellectual disability due to encephalocele',
    sequela_2123: 'Mild motor impairment and severe intellectual disability due to encephalocele',
    sequela_2126:
        'Moderate motor impairment and severe intellectual disability due to encephalocele',
    sequela_2129: 'Severe motor impairment and severe intellectual disability due to encephalocele',
    sequela_2132: 'Mild motor impairment and profound intellectual disability due to encephalocele',
    sequela_2135:
        'Moderate motor impairment and profound intellectual disability due to encephalocele',
    sequela_2138:
        'Severe motor impairment and profound intellectual disability due to encephalocele',
    sequela_2141:
        'Mild motor impairment, borderline intellectual disability and incontinence due to encephalocele',
    sequela_2144:
        'Moderate motor impairment, borderline intellectual disability and incontinence due to encephalocele',
    sequela_2147:
        'Severe motor impairment, borderline intellectual disability and incontinence due to encephalocele',
    sequela_2150:
        'Mild motor impairment, mild intellectual disability and incontinence due to encephalocele',
    sequela_2153:
        'Moderate motor impairment, mild intellectual disability and incontinence due to encephalocele',
    sequela_2156:
        'Severe motor impairment, mild intellectual disability and incontinence due to encephalocele',
    sequela_2159:
        'Mild motor impairment, moderate intellectual disability and incontinence due to encephalocele',
    sequela_2162:
        'Moderate motor impairment, moderate intellectual disability and incontinence due to encephalocele',
    sequela_2165:
        'Severe motor impairment, moderate intellectual disability and incontinence due to encephalocele',
    sequela_2168:
        'Mild motor impairment, severe intellectual disability and incontinence due to encephalocele',
    sequela_2171:
        'Moderate motor impairment, severe intellectual disability and incontinence due to encephalocele',
    sequela_2174:
        'Severe motor impairment, severe intellectual disability and incontinence due to encephalocele',
    sequela_2177:
        'Mild motor impairment, profound intellectual disability and incontinence due to encephalocele',
    sequela_2180:
        'Moderate motor impairment, profound intellectual disability and incontinence due to encephalocele',
    sequela_2183:
        'Severe motor impairment, profound intellectual disability and incontinence due to encephalocele',
    sequela_2189: 'Asymptomatic vitamin A deficiency',
    sequela_2192: 'Latent tuberculosis infection',
    sequela_2204: 'Mild pain due to Guinea worm emergence',
    sequela_2660: 'Chronic other sense organ diseases',
    sequela_4586: 'Mild symptomatic episodes gallbladder and biliary diseases',
    sequela_4589: 'Moderate symptomatic episodes gallbladder and biliary diseases',
    sequela_4592: 'Severe symptomatic episodes gallbladder and biliary diseases',
    sequela_4595: 'Mild symptomatic inguinal, femoral and abdominal hernia',
    sequela_4598: 'Moderate symptomatic inguinal, femoral and abdominal hernia',
    sequela_4601: 'Severe symptomatic inguinal, femoral and abdominal hernia',
    sequela_4604: 'Asymptomatic ulcerative colitis',
    sequela_4607: "Asymptomatic Crohn's disease",
    sequela_4610: 'Mild chronic pancreatitis',
    sequela_4613: 'Moderate chronic pancreatitis',
    sequela_4616: 'Severe chronic pancreatitis',
    sequela_4619: 'Mild acne vulgaris',
    sequela_4622: 'Moderate acne vulgaris',
    sequela_4625: 'Severe acne vulgaris',
    sequela_4628: 'Moderate cellulitis',
    sequela_4631: 'Mild urolithiasis episodes',
    sequela_4634: 'Moderate urolithiasis episodes',
    sequela_4637: 'Severe urolithiasis episodes',
    sequela_4640:
        'Congenital heart disease without intellectual disability or heart failure due to other congenital cardiovascular anomalies',
    sequela_4643:
        'Congenital heart disease and borderline intellectual disability without heart failure due to other congenital cardiovascular anomalies',
    sequela_4646:
        'Congenital heart disease and mild intellectual disability without heart failure due to other congenital cardiovascular anomalies',
    sequela_4649:
        'Congenital heart disease and moderate intellectual disability without heart failure due to other congenital cardiovascular anomalies',
    sequela_4652:
        'Congenital heart disease and severe intellectual disability without heart failure due to other congenital cardiovascular anomalies',
    sequela_4655:
        'Congenital heart disease and profound intellectual disability without heart failure due to other congenital cardiovascular anomalies',
    sequela_4658:
        'Congenital heart disease without intellectual disability or heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4661:
        'Congenital heart disease and borderline intellectual disability without heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4664:
        'Congenital heart disease and mild intellectual disability without heart failure  due to single ventricle and single ventricle pathway heart defects',
    sequela_4667:
        'Congenital heart disease and moderate intellectual disability without heart failure  due to single ventricle and single ventricle pathway heart defects',
    sequela_4670:
        'Congenital heart disease and severe intellectual disability without heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4673:
        'Congenital heart disease and profound intellectual disability without heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4676:
        'Congenital heart disease and mild heart failure without intellectual disability due to single ventricle and single ventricle pathway heart defects',
    sequela_4679:
        'Congenital heart disease, boderline intellectual disability and mild heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4682:
        'Congenital heart disease, mild intellectual disability and mild heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4685:
        'Congenital heart disease, moderate intellectual disability and mild heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4688:
        'Congenital heart disease, severe intellectual disability and mild heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4691:
        'Congenital heart disease, profound intellectual disability and mild heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4694:
        'Congenital heart disease and moderate heart failure without intellectual disability due to single ventricle and single ventricle pathway heart defects',
    sequela_4697:
        'Congenital heart disease, borderline intellectual disability and moderate heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4700:
        'Congenital heart disease, mild intellectual disability and moderate heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4703:
        'Congenital heart disease, moderate intellectual disability and moderate heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4706:
        'Congenital heart disease, severe intellectual disability and moderate heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4709:
        'Congenital heart disease, profound intellectual disability and moderate heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4712:
        'Congenital heart disease and severe heart failure without intellectual disability due to single ventricle and single ventricle pathway heart defects',
    sequela_4715:
        'Congenital heart disease, borderline intellectual disability and severe heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4718:
        'Congenital heart disease, mild intellectual disability and severe heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4721:
        'Congenital heart disease, moderate intellectual disability and severe heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4724:
        'Congenital heart disease, severe intellectual disability and severe heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4727:
        'Congenital heart disease, profound intellectual disability and severe heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_4730:
        'Congenital heart disease without intellectual disability or heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4733:
        'Congenital heart disease and borderline intellectual disability without heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4736:
        'Congenital heart disease and mild intellectual disability  without heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4739:
        'Congenital heart disease and moderate intellectual disability  without heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4742:
        'Congenital heart disease and severe intellectual disability  without heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4745:
        'Congenital heart disease and profound intellectual disability without heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4748:
        'Congenital heart disease and mild heart failure without intellectual disability due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4751:
        'Congenital heart disease, boderline intellectual disability and mild heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4754:
        'Congenital heart disease, mild intellectual disability and mild heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4757:
        'Congenital heart disease, moderate intellectual disability and mild heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4760:
        'Congenital heart disease, severe intellectual disability and mild heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4763:
        'Congenital heart disease, profound intellectual disability and mild heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4766:
        'Congenital heart disease and moderate heart failure without intellectual disability due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4769:
        'Congenital heart disease, borderline intellectual disability and moderate heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4772:
        'Congenital heart disease, mild intellectual disability and moderate heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4775:
        'Congenital heart disease, moderate intellectual disability and moderate heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4778:
        'Congenital heart disease, severe intellectual disability and moderate heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4781:
        'Congenital heart disease, profound intellectual disability and moderate heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4784:
        'Congenital heart disease and severe heart failure without intellectual disability due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4787:
        'Congenital heart disease, borderline intellectual disability and severe heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4790:
        'Congenital heart disease, mild intellectual disability and severe heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4793:
        'Congenital heart disease, moderate intellectual disability and severe heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4796:
        'Congenital heart disease, severe intellectual disability and severe heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4799:
        'Congenital heart disease, profound intellectual disability and severe heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_4802:
        'Congenital heart disease without heart failure or intellectual disability due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4805:
        'Congenital heart disease and borderline intellectual disability without heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4808:
        'Congenital heart disease and mild intellectual disability without heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4811:
        'Congenital heart disease and moderate intellectual disability without heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4814:
        'Congenital heart disease and severe intellectual disability without heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4817:
        'Congenital heart disease and profound intellectual disability without heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4820:
        'Congenital heart disease and mild heart failure without intellectual disability due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4823:
        'Congenital heart disease, boderline intellectual disability and mild heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4826:
        'Congenital heart disease, mild intellectual disability and mild heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4829:
        'Congenital heart disease, moderate intellectual disability and mild heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4832:
        'Congenital heart disease, severe intellectual disability and mild heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4835:
        'Congenital heart disease, profound intellectual disability and mild heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4838:
        'Congenital heart disease and moderate heart failure without intellectual disability due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4841:
        'Congenital heart disease, borderline intellectual disability and moderate heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4844:
        'Congenital heart disease, mild intellectual disability and moderate heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4847:
        'Congenital heart disease, moderate intellectual disability and moderate heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4850:
        'Congenital heart disease, severe intellectual disability and moderate heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4853:
        'Congenital heart disease, profound intellectual disability and moderate heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4856:
        'Congenital heart disease and severe heart failure without intellectual disability due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4859:
        'Congenital heart disease, borderline intellectual disability and severe heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4862:
        'Congenital heart disease, mild intellectual disability and severe heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4865:
        'Congenital heart disease, moderate intellectual disability and severe heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4868:
        'Congenital heart disease, severe intellectual disability and severe heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4871:
        'Congenital heart disease, profound intellectual disability and severe heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_4874:
        'Congenital heart disease without heart failure or intellectual disability due to ventricular septal defect and atrial septal defect',
    sequela_4877:
        'Congenital heart disease and borderline intellectual disability without heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4880:
        'Congenital heart disease and mild intellectual disability without heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4883:
        'Congenital heart disease and moderate intellectual disability without heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4886:
        'Congenital heart disease and severe intellectual disability without heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4889:
        'Congenital heart disease and profound intellectual disability without heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4892:
        'Congenital heart disease and mild heart failure without intellectual disability due to ventricular septal defect and atrial septal defect',
    sequela_4895:
        'Congenital heart disease, boderline intellectual disability and mild heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4898:
        'Congenital heart disease, mild intellectual disability and mild heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4901:
        'Congenital heart disease, moderate intellectual disability and mild heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4904:
        'Congenital heart disease, severe intellectual disability and mild heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4907:
        'Congenital heart disease, profound intellectual disability and mild heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4910:
        'Congenital heart disease and moderate heart failure without intellectual disability due to ventricular septal defect and atrial septal defect',
    sequela_4913:
        'Congenital heart disease, borderline intellectual disability and moderate heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4916:
        'Congenital heart disease, mild intellectual disability and moderate heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4919:
        'Congenital heart disease, moderate intellectual disability and moderate heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4922:
        'Congenital heart disease, severe intellectual disability and moderate heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4925:
        'Congenital heart disease, profound intellectual disability and moderate heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4928:
        'Congenital heart disease and severe heart without intellectual disability due to ventricular septal defect and atrial septal defect',
    sequela_4931:
        'Congenital heart disease, borderline intellectual disability and severe heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4934:
        'Congenital heart disease, mild intellectual disability and severe heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4937:
        'Congenital heart disease, moderate intellectual disability and severe heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4940:
        'Congenital heart disease, severe intellectual disability and severe heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4943:
        'Congenital heart disease, profound intellectual disability and severe heart failure due to ventricular septal defect and atrial septal defect',
    sequela_4946: 'Acute adenolymphangitis due to lymphatic filariasis',
    sequela_4949: 'Asymptomatic multiple sclerosis',
    sequela_4952: 'Mild symptomatic peptic ulcer disease with mild anemia',
    sequela_4955: 'Moderate symptomatic peptic ulcer disease with mild anemia',
    sequela_4958: 'Mild symptomatic peptic ulcer disease with moderate anemia',
    sequela_4961: 'Moderate symptomatic peptic ulcer disease with moderate anemia',
    sequela_4964: 'Mild symptomatic peptic ulcer disease with severe anemia',
    sequela_4967: 'Moderate symptomatic peptic ulcer disease with severe anemia',
    sequela_4970: 'Mild symptomatic peptic ulcer disease without anemia',
    sequela_4973: 'Moderate symptomatic peptic ulcer disease without anemia',
    sequela_4976: 'Asymptomatic peptic ulcer disease with mild anemia',
    sequela_4979: 'Asymptomatic peptic ulcer disease with moderate anemia',
    sequela_4982: 'Asymptomatic peptic ulcer disease with severe anemia',
    sequela_4985: 'Mild symptomatic gastritis and duodenitis with mild anemia',
    sequela_4988: 'Moderate symptomatic gastritis and duodenitis with mild anemia',
    sequela_4991: 'Mild symptomatic gastritis and duodenitis with moderate anemia',
    sequela_4994: 'Moderate symptomatic gastritis and duodenitis with moderate anemia',
    sequela_4997: 'Mild symptomatic gastritis and duodenitis with severe anemia',
    sequela_5000: 'Moderate symptomatic gastritis and duodenitis with severe anemia',
    sequela_5003: 'Mild symptomatic gastritis and duodenitis without anemia',
    sequela_5006: 'Moderate symptomatic gastritis and duodenitis without anemia',
    sequela_5009: 'Asymptomatic gastritis and duodenitis with mild anemia',
    sequela_5012: 'Asymptomatic gastritis and duodenitis with moderate anemia',
    sequela_5015: 'Asymptomatic gastritis and duodenitis with severe anemia',
    sequela_5018: 'Severe malaria with mild anemia',
    sequela_5021: 'Severe malaria with moderate anemia',
    sequela_5024: 'Severe malaria with severe anemia',
    sequela_5027: 'Mild malaria with mild anemia',
    sequela_5030: 'Mild malaria with moderate anemia',
    sequela_5033: 'Mild malaria with severe anemia',
    sequela_5036: 'Moderate malaria with mild anemia',
    sequela_5039: 'Moderate malaria with moderate anemia',
    sequela_5042: 'Moderate malaria with severe anemia',
    sequela_5045: 'Asymptomatic peptic ulcer disease without anemia',
    sequela_5048: 'Asymptomatic gastritis and duodenitis without anemia',
    sequela_5051: 'Early HIV with mild anemia',
    sequela_5054: 'Early HIV with moderate anemia',
    sequela_5057: 'Early HIV with severe anemia',
    sequela_5060: 'Early HIV without anemia',
    sequela_5063: 'Symptomatic HIV with mild anemia',
    sequela_5066: 'Symptomatic HIV with moderate anemia',
    sequela_5069: 'Symptomatic HIV with severe anemia',
    sequela_5072: 'Symptomatic HIV without anemia',
    sequela_5075: 'HIV/AIDS with antiretroviral treatment with mild anemia',
    sequela_5078: 'HIV/AIDS with antiretroviral treatment with moderate anemia',
    sequela_5081: 'HIV/AIDS with antiretroviral treatment with severe anemia',
    sequela_5084: 'HIV/AIDS with antiretroviral treatment without anemia',
    sequela_5087: 'AIDS with mild anemia',
    sequela_5090: 'AIDS with moderate anemia',
    sequela_5093: 'AIDS with severe anemia',
    sequela_5096: 'AIDS without anemia',
    sequela_5099: 'HIV/AIDS -  Drug-susceptible Tuberculosis with mild anemia',
    sequela_5102: 'HIV/AIDS -  Drug-susceptible Tuberculosis with moderate anemia',
    sequela_5105: 'HIV/AIDS -  Drug-susceptible Tuberculosis with severe anemia',
    sequela_5108: 'HIV/AIDS -  Drug-susceptible Tuberculosis without anemia',
    sequela_5111:
        'HIV/AIDS - Multidrug-resistant Tuberculosis without extensive drug resistance with mild anemia',
    sequela_5114:
        'HIV/AIDS - Multidrug-resistant Tuberculosis without extensive drug resistance with moderate anemia',
    sequela_5117:
        'HIV/AIDS - Multidrug-resistant Tuberculosis without extensive drug resistance with severe anemia',
    sequela_5120:
        'HIV/AIDS - Multidrug-resistant Tuberculosis without extensive drug resistance without anemia',
    sequela_5123: 'HIV/AIDS - Extensively drug-resistant Tuberculosis with mild anemia',
    sequela_5126: 'HIV/AIDS - Extensively drug-resistant Tuberculosis with moderate anemia',
    sequela_5129: 'HIV/AIDS - Extensively drug-resistant Tuberculosis with severe anemia',
    sequela_5132: 'HIV/AIDS - Extensively drug-resistant Tuberculosis without anemia',
    sequela_5135: 'Cirrhosis and other chronic liver diseases due to hepatitis B, compensated',
    sequela_5138: 'Cirrhosis and other chronic liver diseases due to hepatitis C, compensated',
    sequela_5141: 'Cirrhosis and other chronic liver diseases due to alcohol, compensated',
    sequela_5144: 'Cirrhosis and other chronic liver diseases due to other cause, compensated',
    sequela_5147: 'Severe disfigurement due to adult tertiary syphilis',
    sequela_5150: 'Neurological problems due to adult tertiary syphilis',
    sequela_5153: 'Cardiovascular complications due to adult tertiary syphilis',
    sequela_5156: 'Asymptomatic adult tertiary syphilis',
    sequela_5159: 'Other infectious diseases',
    sequela_5162: 'Other congenital birth defects',
    sequela_5165: 'Ectopic Pregnancy',
    sequela_5168: 'Acute subarachnoid hemorrhage severity level 1',
    sequela_5171: 'Acute subarachnoid hemorrhage severity level 2',
    sequela_5174: 'Acute subarachnoid hemorrhage severity level 3',
    sequela_5177: 'Acute subarachnoid hemorrhage severity level 4',
    sequela_5180: 'Acute subarachnoid hemorrhage severity level 5',
    sequela_5183: 'Asymptomatic chronic subarachnoid hemorrhage',
    sequela_5186: 'Chronic subarachnoid hemorrhage severity level 1',
    sequela_5189: 'Chronic subarachnoid hemorrhage severity level 2',
    sequela_5192: 'Chronic subarachnoid hemorrhage severity level 3',
    sequela_5195: 'Chronic subarachnoid hemorrhage severity level 4',
    sequela_5198: 'Chronic subarachnoid hemorrhage severity level 5',
    sequela_5201: 'End-stage renal disease after transplant due to type 1 diabetes mellitus',
    sequela_5204: 'End-stage renal disease after transplant due to type 2 diabetes mellitus',
    sequela_5207: 'End-stage renal disease on dialysis due to type 1 diabetes mellitus',
    sequela_5210: 'End-stage renal disease on dialysis due to type 2 diabetes mellitus',
    sequela_5213:
        'Stage III chronic kidney disease and severe anemia due to type 1 diabetes mellitus',
    sequela_5216:
        'Stage III chronic kidney disease and severe anemia due to type 2 diabetes mellitus',
    sequela_5219:
        'Stage III chronic kidney disease and moderate anemia due to type 1 diabetes mellitus',
    sequela_5222:
        'Stage III chronic kidney disease and moderate anemia due to type 2 diabetes mellitus',
    sequela_5225:
        'Stage III chronic kidney disease and mild anemia due to type 1 diabetes mellitus',
    sequela_5228:
        'Stage III chronic kidney disease and mild anemia due to type 2 diabetes mellitus',
    sequela_5231: 'Stage III chronic kidney disease without anemia due to type 1 diabetes mellitus',
    sequela_5234: 'Stage III chronic kidney disease without anemia due to type 2 diabetes mellitus',
    sequela_5237:
        'Stage IV chronic kidney disease untreated and severe anemia due to type 1 diabetes mellitus',
    sequela_5240:
        'Stage IV chronic kidney disease untreated and severe anemia due to type 2 diabetes mellitus',
    sequela_5243:
        'Stage IV chronic kidney disease untreated and moderate anemia due to type 1 diabetes mellitus',
    sequela_5246:
        'Stage IV chronic kidney disease untreated and moderate anemia due to type 2 diabetes mellitus',
    sequela_5249:
        'Stage IV chronic kidney disease untreated and mild anemia due to type 1 diabetes mellitus',
    sequela_5252:
        'Stage IV chronic kidney disease untreated and mild anemia due to type 2 diabetes mellitus',
    sequela_5255:
        'Stage IV chronic kidney disease untreated without anemia due to type 1 diabetes mellitus',
    sequela_5258:
        'Stage IV chronic kidney disease untreated without anemia due to type 2 diabetes mellitus',
    sequela_5261:
        'Stage V chronic kidney disease untreated and severe anemia due to type 1 diabetes mellitus',
    sequela_5264:
        'Stage V chronic kidney disease untreated and severe anemia due to type 2 diabetes mellitus',
    sequela_5267:
        'Stage V chronic kidney disease untreated and moderate anemia due to type 1 diabetes mellitus',
    sequela_5270:
        'Stage V chronic kidney disease untreated and moderate anemia due to type 2 diabetes mellitus',
    sequela_5273:
        'Stage V chronic kidney disease untreated and mild anemia due to type 1 diabetes mellitus',
    sequela_5276:
        'Stage V chronic kidney disease untreated and mild anemia due to type 2 diabetes mellitus',
    sequela_5279:
        'Stage V chronic kidney disease untreated without anemia due to type 1 diabetes mellitus',
    sequela_5282:
        'Stage V chronic kidney disease untreated without anemia due to type 2 diabetes mellitus',
    sequela_5285: 'Calcific aortic valve disease after valve intervention',
    sequela_5288: 'Asymptomatic calcific aortic valve disease',
    sequela_5291: 'Mild heart failure due to calcific aortic valve disease',
    sequela_5294: 'Moderate heart failure due to calcific aortic valve disease',
    sequela_5297: 'Severe heart failure due to calcific aortic valve disease',
    sequela_5300: 'Degenerative mitral valve disease after valve intervention',
    sequela_5303: 'Asymptomatic degenerative mitral valve disease',
    sequela_5306: 'Mild heart failure due to degenerative mitral valve disease',
    sequela_5309: 'Moderate heart failure due to degenerative mitral valve disease',
    sequela_5312: 'Severe heart failure due to degenerative mitral valve disease',
    sequela_5321: 'Mild heart failure due to other non-rheumatic valve disease',
    sequela_5324: 'Moderate heart failure due to other non-rheumatic valve disease',
    sequela_5327: 'Severe heart failure due to other non-rheumatic valve disease',
    sequela_5387: 'Cirrhosis and other chronic liver diseases due to MASH, compensated',
    sequela_5390: 'Cirrhosis and other chronic liver diseases due to MASH, decompensated',
    sequela_5393: 'Vitamin A deficiency with mild anemia',
    sequela_5396: 'Vitamin A deficiency with moderate anemia',
    sequela_5399: 'Vitamin A deficiency with severe anemia',
    sequela_5405: 'Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms',
    sequela_5408: 'Benign and in situ intestinal neoplasms',
    sequela_5411: 'Benign and in situ cervical and uterine neoplasms',
    sequela_5414: 'Other benign and in situ neoplasms',
    sequela_5417: 'Diagnosis and primary therapy phase of liver cancer due to MASH',
    sequela_5420: 'Controlled phase of liver cancer due to MASH',
    sequela_5423: 'Metastatic phase of liver cancer due to MASH',
    sequela_5426: 'Terminal phase of liver cancer due to MASH',
    sequela_5429: 'Diabetic foot due to neuropathy due to diabetes mellitus type 1',
    sequela_5432:
        'Diabetic neuropathy due to diabetes mellitus type 1, without diabetic foot or amputation',
    sequela_5435:
        'Diabetic neuropathy and amputation with treatment due to diabetes mellitus type 1',
    sequela_5438:
        'Diabetic neuropathy and amputation without treatment due to diabetes mellitus type 1',
    sequela_5441: 'Uncomplicated diabetes mellitus type 1',
    sequela_5444: 'Moderate vision impairment due to diabetes mellitus type 1 retinopathy',
    sequela_5447: 'Severe vision impairment due to diabetes mellitus type 1 retinopathy',
    sequela_5450: 'Blindness due to diabetes mellitus type 1 retinopathy',
    sequela_5453: 'Diabetic foot due to neuropathy due to diabetes mellitus type 2',
    sequela_5456:
        'Diabetic neuropathy due to diabetes mellitus type 2, without diabetic foot or amputation',
    sequela_5459:
        'Diabetic neuropathy and amputation with treatment due to diabetes mellitus type 2',
    sequela_5462:
        'Diabetic neuropathy and amputation without treatment due to diabetes mellitus type 2',
    sequela_5465: 'Uncomplicated diabetes mellitus type 2',
    sequela_5468: 'Moderate vision impairment due to diabetes mellitus type 2 retinopathy',
    sequela_5471: 'Severe vision impairment due to diabetes mellitus type 2 retinopathy',
    sequela_5474: 'Blindness due to diabetes mellitus type 2 retinopathy',
    sequela_5477:
        'Metabolic dysfunction-associated steatotic liver disease (MASLD) / Metabolic dysfunction-associated steatohepatitis (MASH)',
    sequela_5483: 'Near vision loss',
    sequela_5486: 'Controlled phase of breast cancer, with mastectomy',
    sequela_5489: 'Controlled phase of breast cancer, without mastectomy',
    sequela_5492: 'Mastectomy from breast cancer, beyond 10 years',
    sequela_5495: 'Controlled phase of prostate cancer, with impotence',
    sequela_5498: 'Controlled phase of prostate cancer, with incontinence',
    sequela_5501: 'Controlled phase of prostate cancer, without impotence or incontinence',
    sequela_5504: 'Impotence from prostate cancer, beyond 10 years',
    sequela_5507: 'Incontinence from prostate cancer, beyond 10 years',
    sequela_5510: 'Controlled phase of larynx cancer, with laryngectomy',
    sequela_5513: 'Controlled phase of larynx cancer, without laryngectomy',
    sequela_5516: 'Laryngectomy from larynx cancer, beyond 10 years',
    sequela_5519: 'Controlled phase of colon and rectum cancers, with stoma',
    sequela_5522: 'Controlled phase of colon and rectum cancers, without stoma',
    sequela_5525: 'Stoma from colon and rectum cancers, beyond 10 years',
    sequela_5528: 'Controlled phase of bladder cancer, with incontinence',
    sequela_5531: 'Controlled phase of bladder cancer, without incontinence',
    sequela_5534: 'Incontinence from bladder cancer, beyond 10 years',
    sequela_5537: 'Moderate pain and limited mobility due to guinea worm',
    sequela_5540: 'Albuminuria with preserved GFR due to type 1 diabetes mellitus',
    sequela_5543: 'Albuminuria with preserved GFR due to type 2 diabetes mellitus',
    sequela_5546: 'Albuminuria with preserved GFR due to hypertension',
    sequela_5549: 'Albuminuria with preserved GFR due to glomerulonephritis',
    sequela_5552: 'Albuminuria with preserved GFR due to other and unspecified causes',
    sequela_5555: 'Severe acute iNTS',
    sequela_5558: 'Menstrual disorders without anemia',
    sequela_5567: 'Ulcerative colitis with mild anemia',
    sequela_5570: 'Ulcerative colitis with moderate anemia',
    sequela_5573: 'Ulcerative colitis with severe anemia',
    sequela_5576: 'Ulcerative colitis without anemia',
    sequela_5579: "Crohn's disease with mild anemia",
    sequela_5582: "Crohn's disease with moderate anemia",
    sequela_5585: "Crohn's disease with severe anemia",
    sequela_5588: "Crohn's disease without anemia",
    sequela_5606: 'Mild anemia due to malaria vivax (PvPR)',
    sequela_5609: 'Moderate anemia due to malaria vivax (PvPR)',
    sequela_5612: 'Severe anemia due to malaria vivax (PvPR)',
    sequela_5615: 'Asymptomatic malaria vivax (PvPR)',
    sequela_5618: 'Non-disabling symptomatic acne',
    sequela_5621: 'Acute pancreatitis',
    sequela_5624: 'Complicated peptic ulcer disease with no anemia',
    sequela_5627: 'Complicated peptic ulcer disease with mild anemia',
    sequela_5630: 'Complicated peptic ulcer disease with moderate anemia',
    sequela_5633: 'Complicated peptic ulcer disease with severe anemia',
    sequela_5675: 'Complicated gastritis and duodenitis with no anemia',
    sequela_5678: 'Complicated gastritis and duodenitis with mild anemia',
    sequela_5681: 'Complicated gastritis and duodenitis with moderate anemia',
    sequela_5684: 'Complicated gastritis and duodenitis with severe anemia',
    sequela_5726: 'Controlled, medically managed heart failure due ischemic heart disease',
    sequela_5729: 'Controlled, medically managed heart failure due to alcoholic cardiomyopathy',
    sequela_5732:
        'Controlled, medically managed heart failure due to calcific aortic valve disease',
    sequela_5735: 'Controlled, medically managed heart failure due to Chagas disease',
    sequela_5738:
        'Controlled, medically managed heart failure due to degenerative mitral valve disease',
    sequela_5741: 'Controlled, medically managed heart failure due to endocarditis',
    sequela_5744:
        'Controlled, medically managed heart failure due to endocrine, metabolic, blood, and immune disorders',
    sequela_5747: 'Controlled, medically managed heart failure due to G6PD deficiency',
    sequela_5750: 'Controlled, medically managed heart failure due to hypertensive heart disease',
    sequela_5753: 'Controlled, medically managed heart failure due to myocarditis',
    sequela_5756: 'Controlled, medically managed heart failure due to other cardiomyopathy',
    sequela_5759: 'Controlled, medically managed heart failure due to other cardiovascular disease',
    sequela_5762:
        'Controlled, medically managed heart failure due to other hemoglobinopathies and hemolytic anemias',
    sequela_5765:
        'Controlled, medically managed heart failure due to other non-rheumatic valve disease',
    sequela_5768: 'Controlled, medically managed heart failure due to rheumatic heart disease',
    sequela_5771: 'Controlled, medically managed heart failure due to severe asbestosis',
    sequela_5774:
        'Controlled, medically managed heart failure due to severe chronic obstructive pulmonary disease',
    sequela_5777:
        'Controlled, medically managed heart failure due to severe coal workers pneumoconiosis',
    sequela_5780:
        'Controlled, medically managed heart failure due to severe interstitial lung disease and pulmonary sarcoidosis',
    sequela_5783: 'Controlled, medically managed heart failure due to severe other pneumoconiosis',
    sequela_5786: 'Controlled, medically managed heart failure due to severe silicosis',
    sequela_5789: 'Controlled, medically managed heart failure due to thalassemias',
    sequela_5792:
        'Congenital heart disease and controlled, medically managed heart failure without intellectual disability due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_5795:
        'Congenital heart disease and controlled, medically managed heart failure without intellectual disability due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_5798:
        'Congenital heart disease and controlled, medically managed heart failure without intellectual disability due to single ventricle and single ventricle pathway heart defects',
    sequela_5801:
        'Congenital heart disease and controlled, medically managed heart failure without intellectual disability due to ventricular septal defect and atrial septal defect',
    sequela_5804:
        'Congenital heart disease, boderline intellectual disability and controlled, medically managed heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_5807:
        'Congenital heart disease, boderline intellectual disability and controlled, medically managed heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_5810:
        'Congenital heart disease, boderline intellectual disability and controlled, medically managed heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_5813:
        'Congenital heart disease, boderline intellectual disability and controlled, medically managed heart failure due to ventricular septal defect and atrial septal defect',
    sequela_5816:
        'Congenital heart disease, mild intellectual disability and controlled, medically managed heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_5819:
        'Congenital heart disease, mild intellectual disability and controlled, medically managed heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_5822:
        'Congenital heart disease, mild intellectual disability and controlled, medically managed heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_5825:
        'Congenital heart disease, mild intellectual disability and controlled, medically managed heart failure due to ventricular septal defect and atrial septal defect',
    sequela_5828:
        'Congenital heart disease, moderate intellectual disability and controlled, medically managed heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_5831:
        'Congenital heart disease, moderate intellectual disability and controlled, medically managed heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_5834:
        'Congenital heart disease, moderate intellectual disability and controlled, medically managed heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_5837:
        'Congenital heart disease, moderate intellectual disability and controlled, medically managed heart failure due to ventricular septal defect and atrial septal defect',
    sequela_5840:
        'Congenital heart disease, profound intellectual disability and controlled, medically managed heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_5843:
        'Congenital heart disease, profound intellectual disability and controlled, medically managed heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_5846:
        'Congenital heart disease, profound intellectual disability and controlled, medically managed heart failure due to ventricular septal defect and atrial septal defect',
    sequela_5849:
        'Congenital heart disease, profound intellectual disability and controlled, medically managed heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_5852:
        'Congenital heart disease, severe intellectual disability and controlled, medically managed heart failure due to critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_5855:
        'Congenital heart disease, severe intellectual disability and controlled, medically managed heart failure due to severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_5858:
        'Congenital heart disease, severe intellectual disability and controlled, medically managed heart failure due to single ventricle and single ventricle pathway heart defects',
    sequela_5861:
        'Congenital heart disease, severe intellectual disability and controlled, medically managed heart failure due to ventricular septal defect and atrial septal defect',
    sequela_5864: 'Diagnosis and primary therapy phase of other malignant neoplasms',
    sequela_5867: 'Controlled phase of other malignant neoplasms',
    sequela_5870: 'Metastatic phase of other malignant neoplasms',
    sequela_5873: 'Terminal phase of other malignant neoplasms',
    sequela_5876: 'Other hemoglobinopathies and hemolytic anemias',
    sequela_6092: 'Acne vulgaris',
    sequela_6098: 'Acute endocarditis',
    sequela_6101: 'Acute Hepatitis A episode',
    sequela_6104: 'Acute Hepatitis B episode',
    sequela_6107: 'Acute Hepatitis C episode',
    sequela_6110: 'Acute Hepatitis E episode',
    sequela_6113: 'Acute intracerebral hemorrhage',
    sequela_6116: 'Acute ischemic stroke',
    sequela_6125: 'Acute other sense organ diseases',
    sequela_6131: 'Acute subarachnoid hemorrhage',
    sequela_6134: 'Age-related and other hearing loss',
    sequela_6137: 'Alcohol dependence',
    sequela_6146: 'Anemia due to endocrine, metabolic, blood, and immune disorders',
    sequela_6149: 'Anemia due to hookworm disease',
    sequela_6155: 'Anemia due to other infectious diseases',
    sequela_6158: 'Anemia due to other neglected tropical diseases',
    sequela_6161: 'Anemia due to schistosomiasis',
    sequela_6167: 'Angina due to ischemic heart disease',
    sequela_6170: 'Anxiety disorders',
    sequela_6173: 'Asbestosis without heart failure',
    sequela_6176: 'Ascariasis complications',
    sequela_6182: 'Asymptomatic food-borne tremodiases',
    sequela_6203: 'Attention-deficit/hyperactivity disorder',
    sequela_6206: 'Autism spectrum disorders',
    sequela_6209: 'Basal cell carcinoma',
    sequela_6212: 'Benign prostatic hyperplasia',
    sequela_6215: 'Bipolar disorder',
    sequela_6230: 'Caries of deciduous teeth',
    sequela_6233: 'Caries of permanent teeth',
    sequela_6239: 'Chlamydia episode',
    sequela_6242: 'Chlamydial infection complications',
    sequela_6245: 'Chronic intracerebral hemorrhage',
    sequela_6248: 'Chronic ischemic stroke',
    sequela_6257: 'Chronic obstructive pulmonary disease with heart failure',
    sequela_6260: 'Chronic obstructive pulmonary disease without heart failure',
    sequela_6263: 'Chronic otitis media',
    sequela_6266: 'Chronic subarachnoid hemorrhage',
    sequela_6269: 'Cirrhosis and other chronic liver diseases due to MASH',
    sequela_6275: 'Coal workers pneumoconiosis without heart failure',
    sequela_6284: 'Conduct disorder',
    sequela_6290:
        'Critical malformations of great vessels, congenital valvular heart disease and patent ductus arteriosus',
    sequela_6299: 'Dengue episode',
    sequela_6308: 'Diarrheal disease episode',
    sequela_6320: 'Down syndrome',
    sequela_6323: 'Dysthymia',
    sequela_6326: 'Early syphilis',
    sequela_6335: 'Edentulism and severe tooth loss',
    sequela_6338: 'Encephalocoele due to neural tube defects',
    sequela_6341: 'End-stage chronic kidney disease due to diabetes mellitus type 1',
    sequela_6344: 'End-stage chronic kidney disease due to diabetes mellitus type 2',
    sequela_6347: 'End-stage chronic kidney disease due to glomerulonephritis',
    sequela_6350: 'End-stage chronic kidney disease due to hypertension',
    sequela_6353: 'End-stage chronic kidney disease due to other causes',
    sequela_6356: 'Endocrine, metabolic, blood, and immune disorders',
    sequela_6368: 'Fetal alcohol syndrome',
    sequela_6371: 'Food-borne tremodiases complications',
    sequela_6374: 'G6PD deficiency',
    sequela_6377: 'G6PD trait',
    sequela_6392: 'Genital herpes',
    sequela_6395: 'Genital prolapse',
    sequela_6398: 'Gonococcal infection complications',
    sequela_6401: 'Gonorrhoea episode',
    sequela_6404: 'Gout',
    sequela_6407: 'Guinea worm disease complications',
    sequela_6410: 'Hearing loss due to other congenital anomalies',
    sequela_6413: 'Heart failure due to alcoholic cardiomyopathy',
    sequela_6416: 'Heart failure due to asbestosis',
    sequela_6419: 'Heart failure due to calcific aortic valve disease',
    sequela_6422: 'Heart failure due to Coal workers pneumoconiosis',
    sequela_6425: 'Heart failure due to degenerative mitral valve disease',
    sequela_6428: 'Heart failure due to endocarditis',
    sequela_6431: 'Heart failure due to endocrine, metabolic, blood, and immune disorders',
    sequela_6434: 'Heart failure due to hypertensive heart disease',
    sequela_6437: 'Heart failure due to interstitial lung disease and pulmonary sarcoidosis',
    sequela_6443: 'Heart failure due to ischemic heart disease',
    sequela_6446: 'Heart failure due to myocarditis',
    sequela_6449: 'Heart failure due to other cardiomyopathy',
    sequela_6452: 'Heart failure due to other cardiovascular diseases',
    sequela_6458: 'Heart failure due to other pneumoconiosis',
    sequela_6461: 'Heart failure due to rheumatic heart disease',
    sequela_6464: 'Heart failure due to silicosis',
    sequela_6470: 'Hemolytic disease and other neonatal jaundice',
    sequela_6473: 'Protein-energy malnutrition',
    sequela_6479: 'HIV/AIDS - Extensively drug-resistant Tuberculosis',
    sequela_6482: 'HIV/AIDS - Multidrug-resistant Tuberculosis without extensive drug resistance',
    sequela_6485: 'HIV/AIDS not on antiretroviral treatment without Tuberculosis',
    sequela_6488: 'HIV/AIDS on antiretroviral treatment without Tuberculosis',
    sequela_6494: 'Hookworm disease complications',
    sequela_6497: 'Idiopathic developmental intellectual disability',
    sequela_6500: 'Idiopathic epilepsy',
    sequela_6503: 'Impotence and Incontinence after 10-year survival from prostate cancer',
    sequela_6521: 'Interstitial lung disease and pulmonary sarcoidosis without heart failure',
    sequela_6530: 'Iron-deficiency anemia',
    sequela_6536: 'Klinefelter syndrome',
    sequela_6563: 'Low back pain with leg pain',
    sequela_6566: 'Low back pain without leg pain',
    sequela_6569: 'Lower respiratory infection episode',
    sequela_6572: 'Lymphatic filariasis complications',
    sequela_6575: 'Major depressive disorder',
    sequela_6578: 'Malaria complications',
    sequela_6581: 'Malaria episode',
    sequela_6590: 'Maternal hemorrhage complications',
    sequela_6593: 'Maternal hemorrhage episode',
    sequela_6596: 'Maternal hypertensive disorder complications',
    sequela_6599: 'Maternal hypertensive disorder episode',
    sequela_6602: 'Maternal obstructed labor complications',
    sequela_6608: 'Maternal sepsis and other maternal infection episode',
    sequela_6614: 'Medication overuse headache due to migraine',
    sequela_6617: 'Medication overuse headache due to tension-type headache',
    sequela_6623: 'Migraine',
    sequela_6626: 'Motor neuron disease',
    sequela_6632: 'Multiple sclerosis',
    sequela_6635: 'Myocardial infarction due to ischemic heart disease',
    sequela_6641: 'Neck pain',
    sequela_6644: 'Neonatal encephalopathy due to birth asphyxia and trauma',
    sequela_6647: 'Neonatal sepsis and other neonatal infection complications',
    sequela_6650: 'Neonatal sepsis and other neonatal infection episode',
    sequela_6653: 'Neonatal tetanus complications',
    sequela_6662: 'Non-rheumatic calcific aortic valve disease',
    sequela_6665: 'Non-rheumatic degenerative mitral valve disease',
    sequela_6671: 'Osteoarthritis of the hip',
    sequela_6674: 'Osteoarthritis of the knee',
    sequela_6677: 'Other cardiovascular and circulatory disease episodes',
    sequela_6680: 'Other chromosomal abnormalities',
    sequela_6683: 'Other congenital heart anomalies',
    sequela_6686: 'Other gynecological diseases',
    sequela_6689: 'Other gynecological diseases with anemia',
    sequela_6701: 'Other mental disorders',
    sequela_6704: 'Other musculoskeletal disorders',
    sequela_6710: 'Other oral disorders',
    sequela_6716: 'Other pneumoconiosis without heart failure',
    sequela_6734: 'Paratyphoid fever episode',
    sequela_6764: 'Premenstrual syndrome',
    sequela_6767: 'Preterm birth complications',
    sequela_6773: 'Retinopathy of prematurity',
    sequela_6776: 'Rheumatoid arthritis',
    sequela_6779: 'Schistosomiasis complications',
    sequela_6785: 'Schizophrenia',
    sequela_6788: 'Severe congenital heart anomalies excluding single ventricle heart defects',
    sequela_6791: 'Sickle cell disorders',
    sequela_6794: 'Sickle cell trait',
    sequela_6797: 'Silicosis without heart failure',
    sequela_6800: 'Single ventricle and single ventricle pathway congenital heart anomalies',
    sequela_6803: 'Skin disease due to onchocerciasis',
    sequela_6806: 'Spina bifida due to neural tube defects',
    sequela_6809: 'Squamous cell carcinoma',
    sequela_6812: 'Stage III chronic kidney disease due to diabetes mellitus type 1',
    sequela_6815: 'Stage III chronic kidney disease due to diabetes mellitus type 2',
    sequela_6818: 'Stage III chronic kidney disease due to glomerulonephritis',
    sequela_6821: 'Stage III chronic kidney disease due to hypertension',
    sequela_6824: 'Stage III chronic kidney disease due to other causes',
    sequela_6827: 'Stage IV chronic kidney disease due to diabetes mellitus type 1',
    sequela_6830: 'Stage IV chronic kidney disease due to diabetes mellitus type 2',
    sequela_6833: 'Stage IV chronic kidney disease due to glomerulonephritis',
    sequela_6836: 'Stage IV chronic kidney disease due to hypertension',
    sequela_6839: 'Stage IV chronic kidney disease due to other causes',
    sequela_6842: 'Stage V chronic kidney disease due to diabetes mellitus type 1',
    sequela_6845: 'Stage V chronic kidney disease due to diabetes mellitus type 2',
    sequela_6848: 'Stage V chronic kidney disease due to glomerulonephritis',
    sequela_6851: 'Stage V chronic kidney disease due to hypertension',
    sequela_6854: 'Stage V chronic kidney disease due to other causes',
    sequela_6863: 'Symptomatic asthma',
    sequela_6866: 'Symptomatic chronic Chagas infection',
    sequela_6869: 'Tension-type headache',
    sequela_6872: 'Tertiary syphilis',
    sequela_6881: 'Thalassemias',
    sequela_6893: 'Trichomoniasis',
    sequela_6896: 'Trichuriasis complications',
    sequela_6899: 'Trypanosomiasis Gambiense',
    sequela_6902: 'Trypanosomiasis Rhodesiense',
    sequela_6905: 'Turner syndrome',
    sequela_6908: 'Typhoid fever complications',
    sequela_6911: 'Typhoid fever episode',
    sequela_6914: 'Uncomplicated preterm birth',
    sequela_6926: 'Upper respiratory infection episode',
    sequela_6929: 'Urinary tract infections',
    sequela_6950: 'Ventricular septal defect and atrial septal defect',
    sequela_6953: 'Visceral leishmaniasis',
    sequela_6965: 'Vision loss due to onchocerciasis',
    sequela_6971: 'Vitamin A deficiency complications',
    sequela_6974: 'Vitamin A deficiency with anemia',
    sequela_6977: 'Yellow fever episode',
    sequela_6980: 'Zika virus complications',
    sequela_6983: 'Zika virus episode',
    sequela_6986: 'Encephalitis complications',
    sequela_6989: 'H Influenza type B meningitis complications',
    sequela_6992: 'Meningococcal meningitis complications',
    sequela_6995: 'Other bacterial meningitis complications',
    sequela_6998: 'Pneumococcal meningitis complications',
    sequela_7004: 'Viral warts',
    sequela_7007: 'Molluscum contagiosum',
    sequela_7163: 'Asymptomatic rheumatoid arthritis',
    sequela_7166: 'Symptomatic probable migraine',
    sequela_7169: 'Asymptomatic probable migraine',
    sequela_7172: 'Symptomatic definite migraine',
    sequela_7175: 'Asymptomatic definite migraine',
    sequela_7178: 'Asymptomatic osteoarthritis of the knee',
    sequela_7181: 'Asymptomatic osteoarthritis of the hip',
    sequela_7184: 'Mild to moderate GERD, symptomatic days',
    sequela_7187: 'Mild to moderate GERD, asymptomatic days',
    sequela_7190: 'Severe GERD, symptomatic days',
    sequela_7193: 'Severe GERD, asymptomatic days',
    sequela_7196: 'Asymptomatic chronic pancreatitis',
    sequela_7199: 'Acute peptic ulcer disease, with no anemia',
    sequela_7202: 'Acute peptic ulcer disease, with mild anemia',
    sequela_7205: 'Acute peptic ulcer disease, with moderate anemia',
    sequela_7208: 'Acute peptic ulcer disease, with severe anemia',
    sequela_7211: 'Acute gastritis and duodenitis, with no anemia',
    sequela_7214: 'Acute gastritis and duodenitis, with mild anemia',
    sequela_7217: 'Acute gastritis and duodenitis, with moderate anemia',
    sequela_7220: 'Acute gastritis and duodenitis, with severe anemia',
    sequela_7223:
        'Extreme hyperbilirubinemia due to hemolytic disease and other neonatal jaundice, without kernicterus',
    sequela_7226: 'Basal cell carcinoma without disfigurement',
    sequela_22682: 'HIV/AIDS -  Drug-susceptible Tuberculosis',
    sequela_22685: 'Malaria parasitemia',
    sequela_22688: 'Cystic echinococcosis',
    sequela_22691: 'Vision impairment due to trachoma',
    sequela_22694: 'Leprosy',
    sequela_22697: 'Diphtheria episodes',
    sequela_22700: 'Measles episodes',
    sequela_22703: 'Visible goiter with complications',
    sequela_22706: 'Acute peptic ulcer disease',
    sequela_22709: 'Chronic peptic ulcer disease',
    sequela_22712: 'Acute gastritis and duodenitis',
    sequela_22715: 'Chronic gastritis and duodenitis',
    sequela_22718: 'Gastroesophageal reflux disease',
    sequela_22721: 'Inguinal, femoral and abdominal hernia',
    sequela_22724: 'Chronic pancreatitis',
    sequela_22727: "Alzheimer's disease and other dementias",
    sequela_22730: "Parkinson's disease",
    sequela_22733:
        'Mild motor impairment and moderate respiratory problems due to motor neuron disease',
    sequela_22736: 'Opioid dependence',
    sequela_22739: 'Cocaine dependence',
    sequela_22742: 'Amphetamine dependence',
    sequela_22745: 'Cannabis dependence',
    sequela_22748: 'Vision loss due to diabetes mellitus type 1 retinopathy',
    sequela_22751: 'Vision loss due to diabetes mellitus type 2 retinopathy',
    sequela_22754: 'Atopic dermatitis',
    sequela_22757: 'Contact dermatitis',
    sequela_22760: 'Seborrhoeic dermatitis',
    sequela_22763: 'Psoriasis',
    sequela_22766: 'Cellulitis',
    sequela_22769: 'Alopecia areata',
    sequela_22772: 'Urticaria',
    sequela_22775: 'Decubitus ulcer',
    sequela_22778: 'Other skin and subcutaneous diseases',
    sequela_22781: 'Vision impairment due to glaucoma',
    sequela_22784: 'Vision impairment due to cataract',
    sequela_22787: 'Vision impairment due to macular degeneration',
    sequela_22790: 'Vision impairment due to uncorrected refractive error',
    sequela_22793: 'Vision impairment due to other vision loss',
    sequela_22796: 'Orofacial clefts',
    sequela_22799: 'Polydactyly and syndactyly',
    sequela_22802: 'Congenital limb deficiency',
    sequela_22805: 'Other congenital musculoskeletal anomalies',
    sequela_22808: 'Congenital genital anomalies',
    sequela_22811: 'Congenital diaphragmatic hernia',
    sequela_22814: 'Congenital atresia and/or stenosis of the digestive tract',
    sequela_22817: 'Congenital malformations of the abdominal wall after treatment',
    sequela_22820: 'Other congenital malformations of the digestive tract',
    sequela_22823: 'Urolithiasis episodes',
    sequela_22826: 'Male infertility',
    sequela_22829: 'Uterine fibroids',
    sequela_22832: 'Polycystic ovarian syndrome',
    sequela_22835: 'Female infertility',
    sequela_22838: 'Endometriosis',
    sequela_22841: 'Thalassemia trait',
    sequela_22847: 'Other sexually transmitted diseases',
    sequela_22853: 'Diabetic neuropathy due to diabetes mellitus type 1',
    sequela_22856: 'Diabetic neuropathy due to diabetes mellitus type 2',
    sequela_22857: 'Mild motor plus cognitive impairments due to meningitis',
    sequela_22858: 'Moderately severe hearing loss due to meningitis',
    sequela_22859: 'Profound hearing loss with ringing due to meningitis',
    sequela_22860: 'Moderate motor impairment due to meningitis',
    sequela_22861: 'Blindness due to meningitis',
    sequela_22862: 'Moderate hearing loss with ringing due to meningitis',
    sequela_22863: 'Profound hearing loss due to meningitis',
    sequela_22864: 'Mild intellectual disability due to meningitis',
    sequela_22865: 'Epilepsy due to meningitis',
    sequela_22866: 'Moderate hearing loss due to meningitis',
    sequela_22867: 'Severe hearing loss with ringing due to meningitis',
    sequela_22868: 'Borderline intellectual disability due to meningitis',
    sequela_22869: 'Monocular distance vision loss due to meningitis',
    sequela_22870: 'Severe motor plus cognitive impairments due to meningitis',
    sequela_22871: 'Mild hearing loss with ringing due to meningitis',
    sequela_22872: 'Mild motor impairment due to long term due to meningitis',
    sequela_22873: 'Mild behavioral problems due to meningitis',
    sequela_22874: 'Severe hearing loss due to meningitis',
    sequela_22875: 'Complete hearing loss with ringing due to meningitis',
    sequela_22876: 'Moderate motor plus cognitive impairments due to meningitis',
    sequela_22877: 'Mild hearing loss due to meningitis',
    sequela_22878: 'Acute meningitis',
    sequela_22879: 'Moderately severe hearing loss with ringing due to meningitis',
    sequela_22880: 'Complete hearing loss due to meningitis',
    sequela_22881: 'Severe motor impairment due to meningitis',
    sequela_22882: 'Moderate vision impairment due to meningitis',
    sequela_22883: 'Severe vision impairment due to meningitis',
    sequela_22886: 'Mild osteoarthritis of the hand and foot',
    sequela_22887: 'Moderate osteoarthritis of the hand and foot',
    sequela_22888: 'Severe osteoarthritis of the hand and foot',
    sequela_22889: 'Mild osteoarthritis other',
    sequela_22890: 'Moderate osteoarthritis other',
    sequela_22891: 'Severe osteoarthritis other',
    sequela_22892: 'Diagnosis and primary therapy phase of Burkitt lymphoma',
    sequela_22893: 'Controlled phase of Burkitt lymphoma',
    sequela_22894: 'Metastatic phase of Burkitt lymphoma',
    sequela_22895: 'Terminal phase of Burkitt lymphoma',
    sequela_22896: 'Diagnosis and primary therapy phase of other non-Hodgkin lymphoma',
    sequela_22897: 'Controlled phase of other non-Hodgkin lymphoma',
    sequela_22898: 'Metastatic phase of other non-Hodgkin lymphoma',
    sequela_22899: 'Terminal phase of other non-Hodgkin lymphoma',
    sequela_22900: 'Diagnosis and primary therapy phase of hepatoblastoma',
    sequela_22901: 'Controlled phase of hepatoblastoma',
    sequela_22902: 'Metastatic phase of hepatoblastoma',
    sequela_22903: 'Terminal phase of hepatoblastoma',
    sequela_22912: 'Diagnosis and primary therapy phase of retinoblastoma',
    sequela_22913: 'Controlled phase of retinoblastoma',
    sequela_22914: 'Metastatic phase of retinoblastoma',
    sequela_22915: 'Terminal phase of retinoblastoma',
    sequela_22916: 'Diagnosis and primary therapy phase of other eye cancers',
    sequela_22917: 'Controlled phase of other eye cancers',
    sequela_22918: 'Metastatic phase of other eye cancers',
    sequela_22919: 'Terminal phase of other eye cancers',
    sequela_22920:
        'Diagnosis and primary therapy phase of soft tissue and other extraosseous sarcomas',
    sequela_22921: 'Controlled phase of soft tissue and other extraosseous sarcomas',
    sequela_22922: 'Metastatic phase of soft tissue and other extraosseous sarcomas',
    sequela_22923: 'Terminal phase of soft tissue and other extraosseous sarcomas',
    sequela_22924: 'Diagnosis and primary therapy phase of malignant bone tumors',
    sequela_22925: 'Controlled phase of malignant bone tumors',
    sequela_22926: 'Metastatic phase of malignant bone tumors',
    sequela_22927: 'Terminal phase of malignant bone tumors',
    sequela_22928:
        'Diagnosis and primary therapy phase of neuroblastoma and other peripheral nervous cell tumors',
    sequela_22929: 'Controlled phase of neuroblastoma and other peripheral nervous cell tumors',
    sequela_22930: 'Metastatic phase of neuroblastoma and other peripheral nervous cell tumors',
    sequela_22931: 'Terminal phase of neuroblastoma and other peripheral nervous cell tumors',
    sequela_22932:
        'Controlled, medically managed heart failure due to Pulmonary Arterial Hypertension',
    sequela_22933: 'Mild heart failure due to Pulmonary Arterial Hypertension',
    sequela_22934: 'Moderate heart failure due to Pulmonary Arterial Hypertension',
    sequela_22935: 'Severe heart failure due to Pulmonary Arterial Hypertension',
    sequela_22989:
        'End-stage renal disease on dialysis and mild anemia due to type 1 diabetes mellitus',
    sequela_22990:
        'End-stage renal disease on dialysis and mild anemia due to type 2 diabetes mellitus',
    sequela_22991: 'End-stage renal disease on dialysis and mild anemia due to hypertension',
    sequela_22992: 'End-stage renal disease on dialysis and mild anemia due to glomerulonephritis',
    sequela_22993:
        'End-stage renal disease on dialysis and mild anemia due to other and unspecified causes',
    sequela_22999:
        'End-stage renal disease on dialysis and moderate anemia due to type 1 diabetes mellitus',
    sequela_23000:
        'End-stage renal disease on dialysis and moderate anemia due to type 2 diabetes mellitus',
    sequela_23001: 'End-stage renal disease on dialysis and moderate anemia due to hypertension',
    sequela_23002:
        'End-stage renal disease on dialysis and moderate anemia due to glomerulonephritis',
    sequela_23003:
        'End-stage renal disease on dialysis and moderate anemia due to other and unspecified causes',
    sequela_23009:
        'End-stage renal disease on dialysis and severe anemia due to type 1 diabetes mellitus',
    sequela_23010:
        'End-stage renal disease on dialysis and severe anemia due to type 2 diabetes mellitus',
    sequela_23011: 'End-stage renal disease on dialysis and severe anemia due to hypertension',
    sequela_23012:
        'End-stage renal disease on dialysis and severe anemia due to glomerulonephritis',
    sequela_23013:
        'End-stage renal disease on dialysis and severe anemia due to other and unspecified causes',
    sequela_23019:
        'End-stage renal disease on dialysis without anemia due to type 1 diabetes mellitus',
    sequela_23020:
        'End-stage renal disease on dialysis without anemia due to type 2 diabetes mellitus',
    sequela_23021: 'End-stage renal disease on dialysis without anemia due to hypertension',
    sequela_23022: 'End-stage renal disease on dialysis without anemia due to glomerulonephritis',
    sequela_23023:
        'End-stage renal disease on dialysis without anemia due to other and unspecified causes',
    sequela_23029:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, without anemia',
    sequela_23030:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with mild anemia',
    sequela_23031:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with moderate anemia',
    sequela_23032:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with severe anemia',
    sequela_23033:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with no anemia',
    sequela_23034:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with mild anemia',
    sequela_23035:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with moderate anemia',
    sequela_23036:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with severe anemia',
    sequela_23037:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, without anemia',
    sequela_23038:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with mild anemia',
    sequela_23039:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with moderate anemia',
    sequela_23040:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with severe anemia',
    sequela_23041:
        'Cirrhosis and other chronic liver diseases due to other, decompensated, with no anemia',
    sequela_23042:
        'Cirrhosis and other chronic liver diseases due to other, decompensated, with mild anemia',
    sequela_23043:
        'Cirrhosis and other chronic liver diseases due to other, decompensated, with moderate anemia',
    sequela_23044:
        'Cirrhosis and other chronic liver diseases due to other, decompensated, with severe anemia',
    sequela_23045:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with no anemia',
    sequela_23046:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with mild anemia',
    sequela_23047:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with moderate anemia',
    sequela_23048:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with severe anemia',
    sequela_23049: 'Asymptomatic symptomatic inguinal, femoral and abdominal hernia',
    sequela_23051: 'Asymptomatic osteoarthritis of the hand and foot',
    sequela_23052: 'Asymptomatic osteoarthritis other',
    sequela_23053: 'Symptomatic probable tension-type headache',
    sequela_23054: 'Asymptomatic probable tension-type headache',
    sequela_23055: 'Symptomatic definite tension-type headache',
    sequela_23056: 'Asymptomatic definite tension-type headache',
    sequela_23057:
        'Other combined sequelae of homozygous sickle cell and severe sickle cell/beta-thalassemia',
    sequela_23058: 'Other combined sequelae of hemoglobin SC disease',
    sequela_23059:
        'Other combined sequelae of mild sickle cell/beta-thalassemia exclusivity adjustment',
    sequela_23060: 'Mild schistosomiasis without anemia',
    sequela_23063: 'Asymptomatic congenital syphilis',
    sequela_23087:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with asymptomatic heart failure',
    sequela_23088:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with mild heart failure',
    sequela_23089:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with moderate heart failure',
    sequela_23090:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, with severe heart failure',
    sequela_23091:
        'Cirrhosis and other chronic liver diseases due to hepatitis B, decompensated, without anemia or heart failure',
    sequela_23092:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with asymptomatic heart failure',
    sequela_23093:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with mild heart failure',
    sequela_23094:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with moderate heart failure',
    sequela_23095:
        'Cirrhosis and other chronic liver diseases due to hepatitis C, decompensated, with severe heart failure',
    sequela_23096:
        'Cirrhosis and other chronic liver diseases due to hepatitis c, decompensated, without anemia or heart failure',
    sequela_23097:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with asymptomatic managed heart failure',
    sequela_23098:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with mild heart failure',
    sequela_23099:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with moderate heart failure',
    sequela_23100:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, with severe heart failure',
    sequela_23101:
        'Cirrhosis and other chronic liver diseases due to alcohol, decompensated, without anemia or heart failure',
    sequela_23102:
        'Cirrhosis and other chronic liver diseases due to other cause, decompensated, with asymptomatic heart failure',
    sequela_23103:
        'Cirrhosis and other chronic liver diseases due to other cause, decompensated, with asymptomatic and mild heart failure',
    sequela_23104:
        'Cirrhosis and other chronic liver diseases due to other cause, decompensated, with moderate heart failure',
    sequela_23105:
        'Cirrhosis and other chronic liver diseases due to other cause, decompensated, with severe heart failure',
    sequela_23106:
        'Cirrhosis and other chronic liver diseases due to other causes, decompensated, without anemia or heart failure',
    sequela_23107:
        'Stage 5 chronic kidney disease untreated due to hypertension, with asymptomatic heart failure',
    sequela_23108:
        'Stage 5 chronic kidney disease untreated due to hypertension, with mild heart failure',
    sequela_23109:
        'Stage 5 chronic kidney disease untreated due to hypertension, with moderate heart failure',
    sequela_23110:
        'Stage 5 chronic kidney disease untreated due to hypertension, with severe heart failure',
    sequela_23111:
        'Stage 5 chronic kidney disease untreated due to glomerulonephritis, with asymptomatic heart failure',
    sequela_23112:
        'Stage 5 chronic kidney disease untreated due to glomerulonephritis, with mild heart failure',
    sequela_23113:
        'Stage 5 chronic kidney disease untreated due to glomerulonephritis, with moderate heart failure',
    sequela_23114:
        'Stage 5 chronic kidney disease untreated due to glomerulonephritis, with severe heart failure',
    sequela_23115:
        'Stage 5 chronic kidney disease untreated due to other and unspecified causes, with asymptomatic heart failure',
    sequela_23116:
        'Stage 5 chronic kidney disease untreated due to other and unspecified causes, with mild heart failure',
    sequela_23117:
        'Stage 5 chronic kidney disease untreated due to other and unspecified causes, with moderate heart failure',
    sequela_23118:
        'Stage 5 chronic kidney disease untreated due to other and unspecified causes, with severe heart failure',
    sequela_23119: 'Severe infection associated with beta-thalassemia major',
    sequela_23120: 'Mild anemia due to beta-thalassemia major',
    sequela_23121: 'Moderate anemia due to beta-thalassemia major',
    sequela_23122: 'Severe anemia due to beta-thalassemia major',
    sequela_23124: 'Severe infection associated with hemoglobin E/beta-thalassemia',
    sequela_23129: 'Severe infection associated with hemoglobin H disease',
    sequela_23134:
        'Vaso-occlusive crises due to homozygous sickle cell and severe sickle cell/beta-thalassemia',
    sequela_23135: 'Stroke due to homozygous sickle cell and severe sickle cell/beta-thalassemia ',
    sequela_23136:
        'Vaso-occlusive crises and stroke due to homozygous sickle cell and severe sickle cell/beta-thalassemia',
    sequela_23141: 'Vaso-occlusive crises due to hemoglobin SC disease',
    sequela_23142: 'Stroke due to hemoglobin SC disease',
    sequela_23143: 'Vaso-occlusive crises and stroke due to hemoglobin SC disease',
    sequela_23148: 'Vaso-occlusive crises due to mild sickle cell/beta-thalassemia',
    sequela_23149: 'Stroke due to mild sickle cell/beta-thalassemia',
    sequela_23150: 'Vaso-occlusive crises and stroke due to mild sickle cell/beta-thalassemia',
    sequela_23155: 'G6PD deficiency, with mild anemia',
    sequela_23156: 'G6PD deficiency, with moderate anemia',
    sequela_23157: 'G6PD deficiency, with severe anemia',
    sequela_23158: 'G6PD deficiency, with mild heart failure',
    sequela_23159: 'G6PD deficiency, with moderate heart failure',
    sequela_23160: 'G6PD deficiency, with severe heart failure',
    sequela_23162: 'Mild anemia due to other endocrine, metabolic, blood, immune disorders',
    sequela_23163: 'Moderate anemia due to other endocrine, metabolic, blood, immune disorders',
    sequela_23164: 'Severe anemia due to other endocrine, metabolic, blood, immune disorders',
    sequela_23165: 'Asymptomatic other endocrine, metabolic, blood, immune disorders',
    sequela_23166:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with asymptomatic heart failure',
    sequela_23167:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with mild heart failure',
    sequela_23168:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with moderate heart failure',
    sequela_23169:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, with severe heart failure',
    sequela_23170:
        'Cirrhosis and other chronic liver diseases due to MASH, decompensated, without anemia or heart failure',
    sequela_23171:
        'Stage 5 chronic kidney disease untreated due to type 1 diabetes mellitus, with asymptomatic heart failure',
    sequela_23172:
        'Stage 5 chronic kidney disease untreated due to type 1 diabetes mellitus, with mild heart failure',
    sequela_23173:
        'Stage 5 chronic kidney disease untreated due to type 1 diabetes mellitus, with moderate heart failure',
    sequela_23174:
        'Stage 5 chronic kidney disease untreated due to type 1 diabetes mellitus, with severe heart failure',
    sequela_23175:
        'Stage 5 chronic kidney disease untreated due to type 2 diabetes mellitus, with asymptomatic heart failure',
    sequela_23176:
        'Stage 5 chronic kidney disease untreated due to type 2 diabetes mellitus, with mild heart failure',
    sequela_23177:
        'Stage 5 chronic kidney disease untreated due to type 2 diabetes mellitus, with moderate heart failure',
    sequela_23178:
        'Stage 5 chronic kidney disease untreated due to type 2 diabetes mellitus, with severe heart failure',
    sequela_23179: 'Mild anemia due to hypothyroidism',
    sequela_23180: 'Moderate anemia due to hypothyroidism',
    sequela_23181: 'Severe anemia due to hypothyroidism',
    sequela_23182: 'Mild heart failure due to hypothyroidism',
    sequela_23183: 'Moderate heart failure due to hypothyroidism',
    sequela_23184: 'Severe heart failure due to hypothyroidism',
    sequela_23185: 'Controlled, medically managed heart failure due to hypothyroidism',
    sequela_23186: 'Asymptomatic hypothyroidism',
    sequela_23187: 'Mild anemia due to hyperthyroidism',
    sequela_23188: 'Moderate anemia due to hyperthyroidism',
    sequela_23189: 'Severe anemia due to hyperthyroidism',
    sequela_23190: 'Mild heart failure due to hyperthyroidism',
    sequela_23191: 'Moderate heart failure due to hyperthyroidism',
    sequela_23192: 'Severe heart failure due to hyperthyroidism',
    sequela_23193: 'Controlled, medically managed heart failure due to hyperthyroidism',
    sequela_23194: 'Asymptomatic hyperthyroidism',
    sequela_23195:
        'Acute intracerebral hemorrhage severity level 2, with asymptomatic heart failure',
    sequela_23196: 'Acute intracerebral hemorrhage severity level 2, with mild heart failure',
    sequela_23197: 'Acute intracerebral hemorrhage severity level 2, with moderate heart failure',
    sequela_23198: 'Acute intracerebral hemorrhage severity level 2, with severe heart failure',
    sequela_23199:
        'Acute intracerebral hemorrhage severity level 3, with asymptomatic heart failure',
    sequela_23200: 'Acute intracerebral hemorrhage severity level 3, with mild heart failure',
    sequela_23201: 'Acute intracerebral hemorrhage severity level 3, with moderate heart failure',
    sequela_23202: 'Acute intracerebral hemorrhage severity level 3, with severe heart failure',
    sequela_23203:
        'Acute intracerebral hemorrhage severity level 4, with asymptomatic heart failure',
    sequela_23204: 'Acute intracerebral hemorrhage severity level 4, with mild heart failure',
    sequela_23205: 'Acute intracerebral hemorrhage severity level 4, with moderate heart failure',
    sequela_23206: 'Acute intracerebral hemorrhage severity level 4, with severe heart failure',
    sequela_23207:
        'Acute intracerebral hemorrhage severity level 5, with asymptomatic heart failure',
    sequela_23208: 'Acute intracerebral hemorrhage severity level 5, with mild heart failure',
    sequela_23209: 'Acute intracerebral hemorrhage severity level 5, with moderate heart failure',
    sequela_23210: 'Acute intracerebral hemorrhage severity level 5, with severe heart failure',
    sequela_23211: 'Acute ischemic stroke severity level 2, with asymptomatic heart failure',
    sequela_23212: 'Acute ischemic stroke severity level 2, with mild heart failure',
    sequela_23213: 'Acute ischemic stroke severity level 2, with moderate heart failure',
    sequela_23214: 'Acute ischemic stroke severity level 2, with severe heart failure',
    sequela_23215: 'Acute ischemic stroke severity level 3, with asymptomatic heart failure',
    sequela_23216: 'Acute ischemic stroke severity level 3, with mild heart failure',
    sequela_23217: 'Acute ischemic stroke severity level 3, with moderate heart failure',
    sequela_23218: 'Acute ischemic stroke severity level 3, with severe heart failure',
    sequela_23219: 'Acute ischemic stroke severity level 4, with asymptomatic heart failure',
    sequela_23220: 'Acute ischemic stroke severity level 4, with mild heart failure',
    sequela_23221: 'Acute ischemic stroke severity level 4, with moderate heart failure',
    sequela_23222: 'Acute ischemic stroke severity level 4, with severe heart failure',
    sequela_23223: 'Acute ischemic stroke severity level 5, with asymptomatic heart failure',
    sequela_23224: 'Acute ischemic stroke severity level 5, with mild heart failure',
    sequela_23225: 'Acute ischemic stroke severity level 5, with moderate heart failure',
    sequela_23226: 'Acute ischemic stroke severity level 5, with severe heart failure',
    sequela_23227:
        'Acute subarachnoid hemorrhage severity level 2, with asymptomatic heart failure',
    sequela_23228: 'Acute subarachnoid hemorrhage severity level 2, with mild heart failure',
    sequela_23229: 'Acute subarachnoid hemorrhage severity level 2, with moderate heart failure',
    sequela_23230: 'Acute subarachnoid hemorrhage severity level 2, with severe heart failure',
    sequela_23231:
        'Acute subarachnoid hemorrhage severity level 3, with asymptomatic heart failure',
    sequela_23232: 'Acute subarachnoid hemorrhage severity level 3, with mild heart failure',
    sequela_23233: 'Acute subarachnoid hemorrhage severity level 3, with moderate heart failure',
    sequela_23234: 'Acute subarachnoid hemorrhage severity level 3, with severe heart failure',
    sequela_23235:
        'Acute subarachnoid hemorrhage severity level 4, with asymptomatic heart failure',
    sequela_23236: 'Acute subarachnoid hemorrhage severity level 4, with mild heart failure',
    sequela_23237: 'Acute subarachnoid hemorrhage severity level 4, with moderate heart failure',
    sequela_23238: 'Acute subarachnoid hemorrhage severity level 4, with severe heart failure',
    sequela_23239:
        'Acute subarachnoid hemorrhage severity level 5, with asymptomatic heart failure',
    sequela_23240: 'Acute subarachnoid hemorrhage severity level 5, with mild heart failure',
    sequela_23241: 'Acute subarachnoid hemorrhage severity level 5, with moderate heart failure',
    sequela_23242: 'Acute subarachnoid hemorrhage severity level 5, with severe heart failure',
    sequela_23243: 'Asymptomatic heart failure due to Severe amphetamine dependence',
    sequela_23244: 'Asymptomatic heart failure due to Severe cocaine dependence',
    sequela_23245: 'Mild heart failure due to Severe amphetamine dependence',
    sequela_23246: 'Mild heart failure due to Severe cocaine dependence',
    sequela_23247: 'Moderate heart failure due to Severe amphetamine dependence',
    sequela_23248: 'Moderate heart failure due to Severe cocaine dependence',
    sequela_23249: 'Pulmonary arterial hypertension with no heart failure',
    sequela_23250: 'Severe heart failure due to Severe amphetamine dependence',
    sequela_23251: 'Severe heart failure due to Severe cocaine dependence',
    sequela_23252: 'Symptomatic atrial fibrilation with mild heart failure',
    sequela_23253: 'Symptomatic atrial fibrilation with moderate heart failure',
    sequela_23254: 'Symptomatic atrial fibrillation with asymptomatic heart failure',
    sequela_23255: 'Symptomatic atrial fibrillation with severe heart failure',
    sequela_23261: 'Ulcerative colitis, symptomatic, without anemia',
    sequela_23262: "Crohn's disease, symptomatic, without anemia",
    sequela_23266: 'Symptomatic hypothyroidism without anemia or heart failure',
    sequela_23267: 'Mild symptomatic hyperthyroidism without anemia or heart failure',
    sequela_23268: 'Moderate/severe symptomatic hyperthyroidism without anemia or heart failure',
    sequela_23270:
        'Moderate symptomatic other endocrine, metabolic, blood, immune disorders without anemia or heart failure',
    sequela_23271:
        'Severe symptomatic other endocrine, metabolic, blood, immune disorders without anemia or heart failure',
    sequela_23272: 'Early symptomatic congenital syphilis, infectious syndrome',
    sequela_23273: 'Early symptomatic congenital syphilis, slight disfigurement',
    sequela_23274: 'Late symptomatic congenital syphilis, slight disfigurement',
    sequela_23275: 'Late symptomatic congenital syphilis, neurosyphilis',
    sequela_23276: 'Late symptomatic congenital syphilis, unilateral hearing loss',
    sequela_23277: 'Late symptomatic congenital syphilis, interstitial keratitis',
    sequela_23278: 'Chronic ischemic stroke severity level 2, with asymptomatic heart failure',
    sequela_23279: 'Chronic ischemic stroke severity level 2, with mild heart failure',
    sequela_23280: 'Chronic ischemic stroke severity level 2, with moderate heart failure',
    sequela_23281: 'Chronic ischemic stroke severity level 2, with severe heart failure',
    sequela_23282: 'Chronic ischemic stroke severity level 2, without heart failure',
    sequela_23283:
        'Chronic ischemic stroke severity level 3, with asymptomatic heart failure, no dementia',
    sequela_23284: 'Chronic ischemic stroke severity level 3, with mild heart failure, no dementia',
    sequela_23285:
        'Chronic ischemic stroke severity level 3, with moderate heart failure, no dementia',
    sequela_23286:
        'Chronic ischemic stroke severity level 3, with severe heart failure, no dementia',
    sequela_23287: 'Chronic ischemic stroke severity level 3, without heart failure, no dementia',
    sequela_23288: 'Chronic ischemic stroke severity level 4, with asymptomatic heart failure',
    sequela_23289: 'Chronic ischemic stroke severity level 4, with mild heart failure',
    sequela_23290: 'Chronic ischemic stroke severity level 4, with moderate heart failure',
    sequela_23291: 'Chronic ischemic stroke severity level 4, with severe heart failure',
    sequela_23292: 'Chronic ischemic stroke severity level 4, without heart failure',
    sequela_23293: 'Chronic ischemic stroke severity level 5, without heart failure, no dementia',
    sequela_23294:
        'Chronic ischemic stroke severity level 5, with asymptomatic heart failure, no dementia',
    sequela_23295: 'Chronic ischemic stroke severity level 5, with mild heart failure, no dementia',
    sequela_23296:
        'Chronic ischemic stroke severity level 5, with moderate heart failure, no dementia',
    sequela_23297:
        'Chronic ischemic stroke severity level 5, with severe heart failure, no dementia',
    sequela_23298:
        'Chronic subarachnoid hemorrhage severity level 2, with asymptomatic heart failure',
    sequela_23299: 'Chronic subarachnoid hemorrhage severity level 2, with mild heart failure',
    sequela_23300: 'Chronic subarachnoid hemorrhage severity level 2, with moderate heart failure',
    sequela_23301: 'Chronic subarachnoid hemorrhage severity level 2, with severe heart failure',
    sequela_23302: 'Chronic subarachnoid hemorrhage severity level 2, without heart failure',
    sequela_23303:
        'Chronic subarachnoid hemorrhage severity level 3, with asymptomatic heart failure, no dementia',
    sequela_23304:
        'Chronic subarachnoid hemorrhage severity level 3, with mild heart failure, no dementia',
    sequela_23305:
        'Chronic subarachnoid hemorrhage severity level 3, with moderate heart failure, no dementia',
    sequela_23306:
        'Chronic subarachnoid hemorrhage severity level 3, with severe heart failure, no dementia',
    sequela_23307:
        'Chronic subarachnoid hemorrhage severity level 3, without heart failure, no dementia',
    sequela_23308:
        'Chronic subarachnoid hemorrhage severity level 4, with asymptomatic heart failure',
    sequela_23309: 'Chronic subarachnoid hemorrhage severity level 4, with mild heart failure',
    sequela_23310: 'Chronic subarachnoid hemorrhage severity level 4, with moderate heart failure',
    sequela_23311: 'Chronic subarachnoid hemorrhage severity level 4, with severe heart failure',
    sequela_23312: 'Chronic subarachnoid hemorrhage severity level 4, without heart failure',
    sequela_23313:
        'Chronic subarachnoid hemorrhage severity level 5, with asymptomatic heart failure, no dementia',
    sequela_23314:
        'Chronic subarachnoid hemorrhage severity level 5, with mild heart failure, no dementia',
    sequela_23315:
        'Chronic subarachnoid hemorrhage severity level 5, with moderate heart failure, no dementia',
    sequela_23316:
        'Chronic subarachnoid hemorrhage severity level 5, with severe heart failure, no dementia',
    sequela_23317:
        'Chronic subarachnoid hemorrhage severity level 5, without heart failure, no dementia',
    sequela_23318:
        'Chronic intracerebral hemorrhage severity level 2, with asymptomatic heart failure',
    sequela_23319: 'Chronic intracerebral hemorrhage severity level 2, with mild heart failure',
    sequela_23320: 'Chronic intracerebral hemorrhage severity level 2, with moderate heart failure',
    sequela_23321: 'Chronic intracerebral hemorrhage severity level 2, with severe heart failure',
    sequela_23322: 'Chronic intracerebral hemorrhage severity level 2, without heart failure',
    sequela_23323:
        'Chronic intracerebral hemorrhage severity level 3, with asymptomatic heart failure, no dementia',
    sequela_23324:
        'Chronic intracerebral hemorrhage severity level 3, with mild heart failure, no dementia',
    sequela_23325:
        'Chronic intracerebral hemorrhage severity level 3, with moderate heart failure, no dementia',
    sequela_23326:
        'Chronic intracerebral hemorrhage severity level 3, with severe heart failure, no dementia',
    sequela_23327:
        'Chronic intracerebral hemorrhage severity level 3, without heart failure, no dementia',
    sequela_23328:
        'Chronic intracerebral hemorrhage severity level 4, with asymptomatic heart failure',
    sequela_23329: 'Chronic intracerebral hemorrhage severity level 4, with mild heart failure',
    sequela_23330: 'Chronic intracerebral hemorrhage severity level 4, with moderate heart failure',
    sequela_23331: 'Chronic intracerebral hemorrhage severity level 4, with severe heart failure',
    sequela_23332: 'Chronic intracerebral hemorrhage severity level 4, without heart failure',
    sequela_23333:
        'Chronic intracerebral hemorrhage severity level 5, with asymptomatic heart failure, no dementia',
    sequela_23334:
        'Chronic intracerebral hemorrhage severity level 5, with mild heart failure, no dementia',
    sequela_23335:
        'Chronic intracerebral hemorrhage severity level 5, with moderate heart failure, no dementia',
    sequela_23336:
        'Chronic intracerebral hemorrhage severity level 5, with severe heart failure, no dementia',
    sequela_23337:
        'Chronic intracerebral hemorrhage severity level 5, without heart failure, no dementia',
    sequela_23338:
        'Chronic ischemic stroke severity level 3, with asymptomatic heart failure, with mild dementia',
    sequela_23339:
        'Chronic ischemic stroke severity level 3, with mild heart failure, with mild dementia',
    sequela_23340:
        'Chronic ischemic stroke severity level 3, with moderate heart failure, with mild dementia',
    sequela_23341:
        'Chronic ischemic stroke severity level 3, with severe heart failure, with mild dementia',
    sequela_23342:
        'Chronic ischemic stroke severity level 3, without heart failure, with mild dementia',
    sequela_23343:
        'Chronic ischemic stroke severity level 5, without heart failure, with mild dementia',
    sequela_23344:
        'Chronic ischemic stroke severity level 5, with asymptomatic heart failure, with mild dementia',
    sequela_23345:
        'Chronic ischemic stroke severity level 5, with mild heart failure, with mild dementia',
    sequela_23346:
        'Chronic ischemic stroke severity level 5, with moderate heart failure, with mild dementia',
    sequela_23347:
        'Chronic ischemic stroke severity level 5, with severe heart failure, with mild dementia',
    sequela_23348:
        'Chronic subarachnoid hemorrhage severity level 3, with asymptomatic heart failure, with mild dementia',
    sequela_23349:
        'Chronic subarachnoid hemorrhage severity level 3, with mild heart failure, with mild dementia',
    sequela_23350:
        'Chronic subarachnoid hemorrhage severity level 3, with moderate heart failure, with mild dementia',
    sequela_23351:
        'Chronic subarachnoid hemorrhage severity level 3, with severe heart failure, with mild dementia',
    sequela_23352:
        'Chronic subarachnoid hemorrhage severity level 3, without heart failure, with mild dementia',
    sequela_23353:
        'Chronic subarachnoid hemorrhage severity level 5, with asymptomatic heart failure, with mild dementia',
    sequela_23354:
        'Chronic subarachnoid hemorrhage severity level 5, with mild heart failure, with mild dementia',
    sequela_23355:
        'Chronic subarachnoid hemorrhage severity level 5, with moderate heart failure, with mild dementia',
    sequela_23356:
        'Chronic subarachnoid hemorrhage severity level 5, with severe heart failure, with mild dementia',
    sequela_23357:
        'Chronic subarachnoid hemorrhage severity level 5, without heart failure, with mild dementia',
    sequela_23358:
        'Chronic intracerebral hemorrhage severity level 3, with asymptomatic heart failure, with mild dementia',
    sequela_23359:
        'Chronic intracerebral hemorrhage severity level 3, with mild heart failure, with mild dementia',
    sequela_23360:
        'Chronic intracerebral hemorrhage severity level 3, with moderate heart failure, with mild dementia',
    sequela_23361:
        'Chronic intracerebral hemorrhage severity level 3, with severe heart failure, with mild dementia',
    sequela_23362:
        'Chronic intracerebral hemorrhage severity level 3, without heart failure, with mild dementia',
    sequela_23363:
        'Chronic intracerebral hemorrhage severity level 5, with asymptomatic heart failure, with mild dementia',
    sequela_23364:
        'Chronic intracerebral hemorrhage severity level 5, with mild heart failure, with mild dementia',
    sequela_23365:
        'Chronic intracerebral hemorrhage severity level 5, with moderate heart failure, with mild dementia',
    sequela_23366:
        'Chronic intracerebral hemorrhage severity level 5, with severe heart failure, with mild dementia',
    sequela_23367:
        'Chronic intracerebral hemorrhage severity level 5, without heart failure, with mild dementia',
    sequela_23368:
        'Chronic ischemic stroke severity level 3, with asymptomatic heart failure, with moderate dementia',
    sequela_23369:
        'Chronic ischemic stroke severity level 3, with mild heart failure, with moderate dementia',
    sequela_23370:
        'Chronic ischemic stroke severity level 3, with moderate heart failure, with moderate dementia',
    sequela_23371:
        'Chronic ischemic stroke severity level 3, with severe heart failure, with moderate dementia',
    sequela_23372:
        'Chronic ischemic stroke severity level 3, without heart failure, with moderate dementia',
    sequela_23373:
        'Chronic ischemic stroke severity level 5, without heart failure, with moderate dementia',
    sequela_23374:
        'Chronic ischemic stroke severity level 5, with asymptomatic heart failure, with moderate dementia',
    sequela_23375:
        'Chronic ischemic stroke severity level 5, with mild heart failure, with moderate dementia',
    sequela_23376:
        'Chronic ischemic stroke severity level 5, with moderate heart failure, with moderate dementia',
    sequela_23377:
        'Chronic ischemic stroke severity level 5, with severe heart failure, with moderate dementia',
    sequela_23378:
        'Chronic subarachnoid hemorrhage severity level 3, with asymptomatic heart failure, with moderate dementia',
    sequela_23379:
        'Chronic subarachnoid hemorrhage severity level 3, with mild heart failure, with moderate dementia',
    sequela_23380:
        'Chronic subarachnoid hemorrhage severity level 3, with moderate heart failure, with moderate dementia',
    sequela_23381:
        'Chronic subarachnoid hemorrhage severity level 3, with severe heart failure, with moderate dementia',
    sequela_23382:
        'Chronic subarachnoid hemorrhage severity level 3, without heart failure, with moderate dementia',
    sequela_23383:
        'Chronic subarachnoid hemorrhage severity level 5, with asymptomatic heart failure, with moderate dementia',
    sequela_23384:
        'Chronic subarachnoid hemorrhage severity level 5, with mild heart failure, with moderate dementia',
    sequela_23385:
        'Chronic subarachnoid hemorrhage severity level 5, with moderate heart failure, with moderate dementia',
    sequela_23386:
        'Chronic subarachnoid hemorrhage severity level 5, with severe heart failure, with moderate dementia',
    sequela_23387:
        'Chronic subarachnoid hemorrhage severity level 5, without heart failure, with moderate dementia',
    sequela_23388:
        'Chronic intracerebral hemorrhage severity level 3, with asymptomatic heart failure, with moderate dementia',
    sequela_23389:
        'Chronic intracerebral hemorrhage severity level 3, with mild heart failure, with moderate dementia',
    sequela_23390:
        'Chronic intracerebral hemorrhage severity level 3, with moderate heart failure, with moderate dementia',
    sequela_23391:
        'Chronic intracerebral hemorrhage severity level 3, with severe heart failure, with moderate dementia',
    sequela_23392:
        'Chronic intracerebral hemorrhage severity level 3, without heart failure, with moderate dementia',
    sequela_23393:
        'Chronic intracerebral hemorrhage severity level 5, with asymptomatic heart failure, with moderate dementia',
    sequela_23394:
        'Chronic intracerebral hemorrhage severity level 5, with mild heart failure, with moderate dementia',
    sequela_23395:
        'Chronic intracerebral hemorrhage severity level 5, with moderate heart failure, with moderate dementia',
    sequela_23396:
        'Chronic intracerebral hemorrhage severity level 5, with severe heart failure, with moderate dementia',
    sequela_23397:
        'Chronic intracerebral hemorrhage severity level 5, without heart failure, with moderate dementia',
    sequela_23398:
        'Chronic ischemic stroke severity level 3, with asymptomatic heart failure, with severe dementia',
    sequela_23399:
        'Chronic ischemic stroke severity level 3, with mild heart failure, with severe dementia',
    sequela_23400:
        'Chronic ischemic stroke severity level 3, with moderate heart failure, with severe dementia',
    sequela_23401:
        'Chronic ischemic stroke severity level 3, with severe heart failure, with severe dementia',
    sequela_23402:
        'Chronic ischemic stroke severity level 3, without heart failure, with severe dementia',
    sequela_23403:
        'Chronic ischemic stroke severity level 5, without heart failure, with severe dementia',
    sequela_23404:
        'Chronic ischemic stroke severity level 5, with asymptomatic heart failure, with severe dementia',
    sequela_23405:
        'Chronic ischemic stroke severity level 5, with mild heart failure, with severe dementia',
    sequela_23406:
        'Chronic ischemic stroke severity level 5, with moderate heart failure, with severe dementia',
    sequela_23407:
        'Chronic ischemic stroke severity level 5, with severe heart failure, with severe dementia',
    sequela_23408:
        'Chronic subarachnoid hemorrhage severity level 3, with asymptomatic heart failure, with severe dementia',
    sequela_23409:
        'Chronic subarachnoid hemorrhage severity level 3, with mild heart failure, with severe dementia',
    sequela_23410:
        'Chronic subarachnoid hemorrhage severity level 3, with moderate heart failure, with severe dementia',
    sequela_23411:
        'Chronic subarachnoid hemorrhage severity level 3, with severe heart failure, with severe dementia',
    sequela_23412:
        'Chronic subarachnoid hemorrhage severity level 3, without heart failure, with severe dementia',
    sequela_23413:
        'Chronic subarachnoid hemorrhage severity level 5, with asymptomatic heart failure, with severe dementia',
    sequela_23414:
        'Chronic subarachnoid hemorrhage severity level 5, with mild heart failure, with severe dementia',
    sequela_23415:
        'Chronic subarachnoid hemorrhage severity level 5, with moderate heart failure, with severe dementia',
    sequela_23416:
        'Chronic subarachnoid hemorrhage severity level 5, with severe heart failure, with severe dementia',
    sequela_23417:
        'Chronic subarachnoid hemorrhage severity level 5, without heart failure, with severe dementia',
    sequela_23418:
        'Chronic intracerebral hemorrhage severity level 3, with asymptomatic heart failure, with severe dementia',
    sequela_23419:
        'Chronic intracerebral hemorrhage severity level 3, with mild heart failure, with severe dementia',
    sequela_23420:
        'Chronic intracerebral hemorrhage severity level 3, with moderate heart failure, with severe dementia',
    sequela_23421:
        'Chronic intracerebral hemorrhage severity level 3, with severe heart failure, with severe dementia',
    sequela_23422:
        'Chronic intracerebral hemorrhage severity level 3, without heart failure, with severe dementia',
    sequela_23423:
        'Chronic intracerebral hemorrhage severity level 5, with asymptomatic heart failure, with severe dementia',
    sequela_23424:
        'Chronic intracerebral hemorrhage severity level 5, with mild heart failure, with severe dementia',
    sequela_23425:
        'Chronic intracerebral hemorrhage severity level 5, with moderate heart failure, with severe dementia',
    sequela_23426:
        'Chronic intracerebral hemorrhage severity level 5, with severe heart failure, with severe dementia',
    sequela_23427:
        'Chronic intracerebral hemorrhage severity level 5, without heart failure, with severe dementia',
    sequela_23428: 'Post-acute fatigue syndrome due to COVID-19',
    sequela_23429: 'Post-acute mild cognitive symptoms due to COVID-19',
    sequela_23430: 'Post-acute severe cognitive symptoms due to COVID-19',
    sequela_23431: 'Post-acute mild respiratory symptoms due to COVID-19',
    sequela_23432: 'Post-acute moderate respiratory symptoms due to COVID-19',
    sequela_23433: 'Post-acute severe respiratory symptoms due to COVID-19',
    sequela_23434: 'Post-acute fatigue syndrome and mild cognitive symptoms due to COVID-19',
    sequela_23435: 'Post-acute fatigue syndrome and severe cognitive symptoms due to COVID-19',
    sequela_23436: 'Post-acute fatigue syndrome and mild respiratory symptoms due to COVID-19',
    sequela_23437: 'Post-acute fatigue syndrome and moderate respiratory symptoms due to COVID-19',
    sequela_23438: 'Post-acute fatigue syndrome and severe respiratory symptoms due to COVID-19',
    sequela_23439: 'Post-acute mild respiratory and mild cognitive symptoms due to COVID-19',
    sequela_23440: 'Post-acute mild respiratory and severe cognitive symptoms due to COVID-19',
    sequela_23441: 'Post-acute moderate respiratory and mild cognitive symptoms due to COVID-19',
    sequela_23442: 'Post-acute moderate respiratory and severe cognitive symptoms due to COVID-19',
    sequela_23443: 'Post-acute severe respiratory and mild cognitive symptoms due to COVID-19',
    sequela_23444: 'Post-acute severe respiratory and severe cognitive symptoms due to COVID-19',
    sequela_23445:
        'Post-acute fatigue syndrome and mild respiratory and mild cognitive symptoms due to COVID-19',
    sequela_23446:
        'Post-acute fatigue syndrome and mild respiratory and severe cognitive symptoms due to COVID-19',
    sequela_23447:
        'Post-acute fatigue syndrome and moderate respiratory and mild cognitive symptoms due to COVID-19',
    sequela_23448:
        'Post-acute fatigue syndrome and moderate respiratory and severe cognitive symptoms due to COVID-19',
    sequela_23449:
        'Post-acute fatigue syndrome and severe respiratory and mild cognitive symptoms due to COVID-19',
    sequela_23450:
        'Post-acute fatigue syndrome and severe respiratory and severe cognitive symptoms due to COVID-19',
    sequela_23451: 'Asymptomatic COVID-19 cases',
    sequela_23452: 'Mild acute COVID-19',
    sequela_23453: 'Moderate acute COVID-19',
    sequela_23454: 'Severe acute COVID-19',
    sequela_23455: 'Critical acute COVID-19',
    sequela_23456: 'Guillain-Barré Syndrome due to COVID-19',
    sequela_23457:
        'Diagnosis and primary therapy phase of low-grade brain and other central nervous system neoplasms',
    sequela_23458: 'Controlled phase of low-grade brain and other central nervous system neoplasms',
    sequela_23459: 'Metastatic phase of low-grade brain and other central nervous system',
    sequela_23460: 'Terminal phase of low-grade brain and other central nervous system',
    sequela_23461: 'Moderate vision impairment due to other corneal opacities',
    sequela_23462: 'Severe vision impairment due to other corneal opacities',
    sequela_23463: 'Blindness due to other corneal opacities',
    sequela_23464: 'Mild heart failure due to peripartum cardiomyopathy',
    sequela_23465: 'Moderate heart failure due to peripartum cardiomyopathy',
    sequela_23466: 'Severe heart failure due to peripartum cardiomyopathy',
    sequela_23467: 'Controlled, medically managed heart failure due to peripartum cardiomyopathy',
    sequela_23468: 'Gestational diabetes mellitus',
    sequela_23469: 'Asymptomatic diverticular disease',
    sequela_23470: 'Mild abdominopelvic problems due to diverticular disease',
    sequela_23471: 'Moderate abdominopelvic problems due to diverticular disease',
    sequela_23472: 'Severe abdominopelvic problems due to diverticular disease',
    sequela_23488: 'Puerperal sepsis with mild anemia',
    sequela_23489: 'Puerperal sepsis with moderate anemia',
    sequela_23490: 'Puerperal sepsis with severe anemia',

    sequela_1000000: 'Adenocarcinoma - Distant',
    sequela_1000001: 'Adenocarcinoma - Localized',
    sequela_1000002: 'Adenocarcinoma - Regional',
    sequela_1000003: 'Large cell carcinoma - Distant',
    sequela_1000004: 'Large cell carcinoma - Localized',
    sequela_1000005: 'Large cell carcinoma - Regional',
    sequela_1000006: 'Small cell carcinoma - Distant',
    sequela_1000007: 'Small cell carcinoma - Localized',
    sequela_1000008: 'Small cell carcinoma - Regional',
    sequela_1000009: 'Squamous cell carcinoma - Distant',
    sequela_1000010: 'Squamous cell carcinoma - Localized',
    sequela_1000011: 'Squamous cell carcinoma - Regional',
};
